<template>
  <div>
      <!-- 이전 허가서 불러오기 모달 -->
      <div v-if="showLoadModal" class="wp-load-modal-bg" @click.self="closeLoadModal">
        <div class="wp-load-modal">
          <div class="wp-load-modal-header">
            <h3 style="margin:0;">이전 허가서 불러오기</h3>
            <button type="button" class="btn btn-xs flat" @click="closeLoadModal"><i class="icon-close"></i></button>
          </div>
          <div class="wp-load-modal-body">
            <p class="text-888" style="font-size:12px;margin-bottom:12px;">
              본인 인증(발주 담당자·작업 지휘자) 후 이전 허가서/임시저장 내용을 불러옵니다.
              <strong>임시저장 이어작성</strong>은 문서번호를 비우고 검색하세요. (이전 허가서 복제 시에만 문서번호 입력)
            </p>
            <div class="form-group row mb-10">
              <label class="col-3 form-control-label pt-0">발주 담당자 이름</label>
              <div class="col-9"><input type="text" class="form-control" v-model="loadForm.ordererName" placeholder="발주 담당자 이름"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-3 form-control-label pt-0">발주 담당자 이메일</label>
              <div class="col-9"><input type="text" class="form-control" v-model="loadForm.ordererEmail" placeholder="name@navercorp.com"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-3 form-control-label pt-0">작업 지휘자 이름</label>
              <div class="col-9"><input type="text" class="form-control" v-model="loadForm.managerName" placeholder="작업 지휘자 이름"></div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-3 form-control-label pt-0">문서번호(작업계획번호)<br><span class="text-888" style="font-size:11px;font-weight:400;">임시저장 이어작성 시 비움</span></label>
              <div class="col-9"><input type="text" class="form-control" v-model="loadForm.planId" placeholder="이전 허가서 복제 시에만 입력 (예: 세종-20260608-0001)" @keyup.enter="searchReusablePermits"></div>
            </div>
            <div class="btn-wrap mb-10" style="text-align:right;">
              <button class="btn btn-md black" @click="searchReusablePermits" :disabled="!canSearchLoad || loadSearching">
                <i class="icon-search mr-5"></i>{{ loadSearching ? '검색 중...' : '검색' }}
              </button>
            </div>

            <div v-if="loadSearched">
              <div v-if="loadResults.length === 0" class="text-888" style="text-align:center;padding:20px 0;">
                조건에 맞는 허가서가 없습니다. 발주 담당자·작업 지휘자 정보(및 문서번호 입력 시 문서번호)를 다시 확인하세요.
              </div>
              <table v-else class="tbl">
                <colgroup><col width="160px"><col><col width="110px"><col width="150px"><col width="70px"><col width="96px"></colgroup>
                <thead class="no-drag">
                  <tr><th>문서번호</th><th>작업명</th><th>업체명</th><th>작업기간</th><th>상태</th><th></th></tr>
                </thead>
                <tbody>
                  <tr v-for="r in loadResults" :key="r.planId">
                    <td>{{ r.planId }}</td>
                    <td class="ellipsis">{{ r.planName || '-' }}</td>
                    <td class="ellipsis">{{ r.companyName || '-' }}</td>
                    <td>{{ formatPermitPeriod(r) }}</td>
                    <td style="text-align:center;">{{ reusableStatusText(r.status) }}</td>
                    <td style="text-align:center;">
                      <button v-if="r.status === 'DRAFT'" class="btn btn-xs blue" @click="applyLoadedPermit(r, true)">이어서 작성</button>
                      <button v-else class="btn btn-xs light-blue" @click="applyLoadedPermit(r, false)">불러오기</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="box mt-20">
        <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;">
          <h3>작업 기본 정보</h3>
          <button type="button" class="btn btn-md line-2" @click="openLoadModal">
            <i class="icon-refresh mr-5"></i>이전 허가서 불러오기
          </button>
        </div>
        <div class="box-body">
          <form action="">
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span>작업 계획 번호</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control" v-model="planId" disabled>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">전체 작업 일정</span>
              </label>
              <div class="col-6 pt-2">
                <DatePicker class="form-control"
                            type="date"
                            range
                            :append-to-body="false"
                            :popup-style="{ left: 0}"
                            v-model="planDateRange"
                            :clearable="false"
                            :editable="false"
                            :disabled-date="isPlanDateDisabled"
                            @pick="onPlanDatePick"
                            @change="handlePlanDateChange"
                            style="font-size: 12px;"
                            input-class="calendar-input">
                  <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                </DatePicker>
                <div class="text-888 mt-5">작업을 진행하는 전체 기간을 선택합니다. 최대 1년</div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작업 명</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control" v-model="planName">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">업체명</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control" v-model="companyName" disabled>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작업 지휘자</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control" v-model="workManager">
                <div class="text-888 mt-5">작업지휘자는 반드시 작업기간동안 작업장에 상주하며, 전체 작업을 총괄 관리하여야 합니다.</div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작업 지휘자 연락처</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control"
                  :class="{ 'is-invalid': workManagerPhone && !isValidPhone(workManagerPhone) }"
                  v-model="workManagerPhone"
                  @input="workManagerPhone = formatPhone($event.target.value)"
                  placeholder="010-0000-0000" maxlength="13">
                <div v-if="workManagerPhone && !isValidPhone(workManagerPhone)" class="invalid-feedback" style="display:block;font-size:11px;color:#dc3545;">
                  올바른 전화번호 형식을 입력하세요 (예: 010-0000-0000)
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작업인원</span>
              </label>
              <div class="col-3 pt-2">
                <input type="number" class="form-control" min="0" v-model.number="workPeopleCount">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">안전담당자</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control" v-model="safetyManager">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">안전담당자 연락처</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" class="form-control"
                  :class="{ 'is-invalid': safetyManagerPhone && !isValidPhone(safetyManagerPhone) }"
                  v-model="safetyManagerPhone"
                  @input="safetyManagerPhone = formatPhone($event.target.value)"
                  placeholder="010-0000-0000" maxlength="13">
                <div v-if="safetyManagerPhone && !isValidPhone(safetyManagerPhone)" class="invalid-feedback" style="display:block;font-size:11px;color:#dc3545;">
                  올바른 전화번호 형식을 입력하세요 (예: 010-0000-0000)
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작업 위치</span>
              </label>
              <div class="col-10 pt-2">
                <div class="mb-10">
                  <Dropdown v-model="selectedIdcCode" :datasource="idcList" displayName="locationName" valueName="locationCode" itemDisabledField="disabled" :isSelectionFirstData="true" :width="180"/>
                </div>
                <table class="tbl select-tbl wp-location-table">
                  <colgroup>
                    <col width="160px">
                    <col width="160px">
                    <col width="120px">
                    <col>
                  </colgroup>
                  <thead class="no-drag">
                    <tr>
                      <th>구분</th>
                      <th>관</th>
                      <th>층</th>
                      <th>상세위치</th>
                    </tr>
                  </thead>
                  <tbody v-if="!selectedIdc || regionGroups.length === 0">
                    <tr>
                      <td colspan="4" style="text-align:center">데이터가 없습니다.</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <template v-for="region in regionGroups">
                      <template v-for="building in region.buildings">
                        <tr v-for="(row, rowIndex) in building.rows" :key="region.key + '|' + building.key + '|' + row.key">
                          <td v-if="building.isFirst && rowIndex === 0" :rowspan="region.rowspan">{{ region.regionName }}</td>
                          <td v-if="rowIndex === 0" :rowspan="building.rows.length" class="wp-building-cell">{{ building.buildingName }}</td>
                          <td class="wp-floor-cell">
                            <label v-if="row.details && row.details.length" class="md-check" title="이 층 상세위치 전체 선택/해제">
                              <input type="checkbox" :checked="isFloorAllSelected(row)" @change="toggleFloorAll(row)">
                              <i class="blue"></i>{{ row.floorName }}
                            </label>
                            <span v-else>{{ row.floorName }}</span>
                          </td>
                          <td>
                            <template v-if="row.details && row.details.length">
                              <label class="md-check mr-15" v-for="detail in row.details" :key="detail.key" style="margin-bottom:4px;">
                                <input type="checkbox" v-model="selectedFloorKeys" :value="detail.key">
                                <i class="blue"></i>{{ detail.detailName }}
                              </label>
                            </template>
                            <span v-else class="text-888">-</span>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
                <div class="mt-10 wp-selected-locs" v-if="selectedFloorLabels.length">
                  <span class="text-888">선택된 위치</span>
                  <span v-for="(loc, i) in selectedFloorLabels" :key="'sel-loc-'+i"
                        class="tag line-type">{{ loc }}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="box mt-20">
        <div class="box-header">
          <h3>작업위험성평가</h3>
        </div>
        <div class="box-body">
          <div class="mb-10" style="font-weight: 600;">예정 공정표 입력</div>
          <div class="btn-wrap mb-10">
            <button class="btn btn-md blue" @click="loadSelectedLocationsToSchedule">
              <i class="icon-layers mr-5"></i>위치 불러오기
            </button>
            <button class="btn btn-md light-blue" @click="addScheduleRow">
              <i class="icon-plus mr-5"></i>행 추가
            </button>
            <button class="btn btn-md line-2" @click="removeScheduleRows" :disabled="!hasScheduleSelected">
              <i class="icon-minus mr-5"></i>행 삭제
            </button>
            <button class="btn btn-md line-2" @click="downloadScheduleTemplate">
              <i class="icon-download mr-5"></i>엑셀 템플릿 다운로드
            </button>
            <button class="btn btn-md line-2" @click="triggerScheduleUpload">
              <i class="icon-upload mr-5"></i>엑셀 업로드
            </button>
            <input ref="scheduleExcelInput" type="file" class="d-none" accept=".xlsx,.xls" @change="handleScheduleUpload">
          </div>
          <div class="wp-table-scroll">
          <table class="tbl select-tbl wp-schedule-table">
            <colgroup>
              <col width="50px">
              <col width="200px">
              <col width="200px">
              <col width="200px">
              <col width="200px">
              <col width="280px">
              <col width="260px">
            </colgroup>
            <thead class="no-drag">
              <tr>
                <th>
                  <label class="md-check">
                    <input type="checkbox" v-model="scheduleCheckAll">
                    <i class="blue"></i>
                  </label>
                </th>
                <th>구분</th>
                <th>관</th>
                <th>층</th>
                <th>상세위치</th>
                <th>작업항목</th>
                <th>작업 일정</th>
              </tr>
            </thead>
            <tbody v-if="scheduleRows.length === 0">
              <tr>
                <td colspan="7" style="text-align:center">데이터가 없습니다.</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="row in scheduleRows" :key="row.id">
                <td>
                  <label class="md-check">
                    <input type="checkbox" v-model="row.checked">
                    <i class="blue"></i>
                  </label>
                </td>
                <td class="wp-schedule-loc-cell">
                  <Dropdown v-model="row.regionCode"
                            :append-to-body="true"
                            :datasource="scheduleRegions"
                            displayName="locationName"
                            valueName="locationCode"
                            :isSelectionFirstData="false"
                            :width="220"
                            @changeValue="handleScheduleRegionChange(row)"/>
                </td>
                <td class="wp-schedule-loc-cell">
                  <Dropdown v-model="row.buildingCode"
                            :append-to-body="true"
                            :datasource="getScheduleBuildings(row)"
                            displayName="locationName"
                            valueName="locationCode"
                            :isSelectionFirstData="false"
                            :width="190"
                            @changeValue="handleScheduleBuildingChange(row)"/>
                </td>
                <td class="wp-schedule-loc-cell">
                  <Dropdown v-model="row.floorCode"
                            :append-to-body="true"
                            :datasource="getScheduleFloors(row)"
                            displayName="locationName"
                            valueName="locationCode"
                            :isSelectionFirstData="false"
                            :width="190"
                            @changeValue="handleScheduleFloorChange(row)"/>
                </td>
                <td class="wp-schedule-loc-cell">
                  <Dropdown v-model="row.detailCode"
                            :append-to-body="true"
                            :datasource="getScheduleDetails(row)"
                            displayName="locationName"
                            valueName="locationCode"
                            :isSelectionFirstData="false"
                            :width="190"
                            @changeValue="onScheduleDetailChange(row)"/>
                  <input v-if="isScheduleDetailEtc(row)" type="text" class="form-control mt-5"
                         v-model="row.detailLocation" placeholder="기타 상세위치 입력"/>
                </td>
                <td>
                  <input type="text" class="form-control" v-model="row.workItem">
                </td>
                <td>
                  <DatePicker
                    type="date"
                    range
                    :append-to-body="true"
                    :value="getScheduleDateRange(row)"
                    :clearable="false"
                    :editable="false"
                    :disabled-date="scheduleDateDisabledFn"
                    @change="(val) => handleScheduleRangeChange(row, val)"
                    style="font-size: 12px; width: 100%;"
                    input-class="calendar-input">
                    <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
                  </DatePicker>
                </td>
              </tr>
            </tbody>
          </table>
          </div>

          <div class="mt-20" v-if="scheduleTimelineDays.length">
            <div class="mb-10" style="font-weight: 600;">예정 공정표</div>
            <div class="wp-table-scroll">
            <table class="tbl wp-timeline">
              <colgroup>
                <col width="140px">
                <col width="140px">
                <col width="120px">
                <col width="220px">
                <col width="220px">
                <col v-for="day in scheduleTimelineDays" :key="'day-col-' + day.key" :style="timelineDayColStyle">
              </colgroup>
              <thead class="no-drag">
                <tr>
                  <th rowspan="2">구분</th>
                  <th rowspan="2">관</th>
                  <th rowspan="2">층</th>
                  <th rowspan="2">상세위치</th>
                  <th rowspan="2">작업항목</th>
                  <th :colspan="scheduleTimelineDays.length" class="text-center">{{ scheduleTimelineLabel }}</th>
                </tr>
                <tr>
                  <th v-for="day in scheduleTimelineDays" :key="'day-head-' + day.key" class="wp-timeline-day">{{ day.day }}</th>
                </tr>
              </thead>
              <tbody v-if="scheduleRows.length === 0">
                <tr>
                  <td :colspan="5 + scheduleTimelineDays.length" style="text-align:center">데이터가 없습니다.</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-for="(row, index) in scheduleRows" :key="row.id + '-timeline'">
                  <td>{{ getScheduleRegionName(row) }}</td>
                  <td>{{ getScheduleBuildingName(row) }}</td>
                  <td>{{ getScheduleFloorName(row) }}</td>
                  <td class="ellipsis">{{ getScheduleDetailName(row) }}</td>
                  <td class="ellipsis">{{ row.workItem }}</td>
                  <template v-if="getTimelineMeta(row).valid">
                    <td v-if="getTimelineMeta(row).offset > 0" :colspan="getTimelineMeta(row).offset" class="wp-timeline-empty"></td>
                    <td v-if="getTimelineMeta(row).length > 0" :colspan="getTimelineMeta(row).length" class="wp-timeline-span">
                      <div class="wp-timeline-bar" :style="{ backgroundColor: getTimelineColor(index) }"></div>
                    </td>
                    <td v-if="getTimelineMeta(row).remaining > 0" :colspan="getTimelineMeta(row).remaining" class="wp-timeline-empty"></td>
                  </template>
                  <td v-else :colspan="scheduleTimelineDays.length" class="wp-timeline-empty text-888">일정 미입력</td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
          <div class="mt-30">
            <div class="mb-10" style="font-weight: 600;">작업 항목</div>
            <div class="btn-wrap mb-10">
              <!--
              <button class="btn btn-md light-blue" @click="addRow">
                <i class="icon-plus mr-5"></i>행 추가
              </button>
              <button class="btn btn-md line-2" @click="copyRows" :disabled="!hasSelected">
                <i class="icon-copy mr-5"></i>행 복사
              </button>
              <button class="btn btn-md line-2" @click="removeRows" :disabled="!hasSelected">
                <i class="icon-minus mr-5"></i>행 삭제
              </button>
              <button class="btn btn-md line-2" @click="resetRows">
                <i class="icon-refresh mr-5"></i>초기화
              </button>
              -->
              <button class="btn btn-md line-2" @click="applyScheduleToRows">
                <i class="icon-layers mr-5"></i>예정공정표 반영
              </button>
              <!--
              <button class="btn btn-md line-2" @click="downloadWorkItemsTemplate">
                <i class="icon-download mr-5"></i>엑셀 템플릿 다운로드
              </button>
              <button class="btn btn-md line-2" @click="triggerWorkItemsUpload">
                <i class="icon-upload mr-5"></i>엑셀 업로드
              </button>
              <input ref="workItemsExcelInput" type="file" class="d-none" accept=".xlsx,.xls" @change="handleWorkItemsUpload">
              -->
            </div>
            <div class="wp-table-scroll">
            <table class="tbl select-tbl wp-workitem-table">
            <colgroup>
              <col width="50px">
              <col width="170px">
              <col width="130px">
              <col width="180px">
              <col width="180px">
              <col width="180px">
              <col width="180px">
              <col width="180px">
              <col width="200px">
              <col width="100px">
              <col width="200px">
              <col width="110px">
            </colgroup>
            <thead class="no-drag">
              <tr>
                <th>
                  <label class="md-check">
                    <input type="checkbox" v-model="checkAll">
                    <i class="blue"></i>
                  </label>
                </th>
                <th>작업일정</th>
                <th>항목</th>
                <th>작업절차(세부작업순서)</th>
                <th>위험요인</th>
                <th>재해유형</th>
                <th>보호구</th>
                <th>작업도구</th>
                <th>현재 안전보건조치</th>
                <th>위험도</th>
                <th>추가 안전보건 조치</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="rows.length === 0">
              <tr>
                <td colspan="12" style="text-align:center">데이터가 없습니다.</td>
              </tr>
            </tbody>
            <tbody v-else>
              <template v-for="row in rows">
                <tr v-for="(set, setIndex) in row.sets" :key="row.id + '-' + setIndex">
                  <td v-if="setIndex === 0" :rowspan="row.sets.length" style="vertical-align:middle; text-align:center;">
                    <label class="md-check">
                      <input type="checkbox" v-model="row.checked">
                      <i class="blue"></i>
                    </label>
                  </td>
                  <td v-if="setIndex === 0" :rowspan="row.sets.length" style="vertical-align:middle;">
                    <div class="td-box">
                      <DatePicker
                        type="date"
                        range
                        :append-to-body="true"
                        :value="getScheduleDateRange(row)"
                        :clearable="false"
                        :editable="false"
                        :disabled="true"
                        style="font-size: 12px; width: 100%;"
                        input-class="calendar-input">
                        <i slot="icon-calendar" class="icon-calendar" style="color: #222;"></i>
                      </DatePicker>
                    </div>
                  </td>
                  <td v-if="setIndex === 0" :rowspan="row.sets.length" style="vertical-align:middle;">
                    <div class="td-box">
                      <input type="text" class="form-control" :value="row.item" readonly style="background:#f8f8f8;">
                    </div>
                  </td>
                  <td>
                    <div class="td-box">
                      <input type="text" class="form-control" v-model="set.procedure">
                    </div>
                  </td>
                  <td>
                    <div class="td-box">
                      <input type="text" class="form-control" v-model="set.riskFactor" placeholder="위험요인 입력">
                    </div>
                  </td>
                  <td>
                    <div class="td-box table-list">
                      <div class="table-list-item">
                        <input type="text" class="form-control" :value="getSelectLabel(set.hazard)" placeholder="재해유형 선택" readonly @click="openSelectModal(row, setIndex, 'hazard')">
                        <button class="btn btn-xs line-2" @click="openSelectModal(row, setIndex, 'hazard')">선택</button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="td-box table-list">
                      <div class="table-list-item">
                        <input type="text" class="form-control" :value="getSelectLabel(set.protection)" placeholder="보호구 선택" readonly @click="openSelectModal(row, setIndex, 'protection')">
                        <button class="btn btn-xs line-2" @click="openSelectModal(row, setIndex, 'protection')">선택</button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="td-box table-list">
                      <div class="table-list-item">
                        <input type="text" class="form-control" :value="getSelectLabel(set.tool)" placeholder="작업도구 선택" readonly @click="openSelectModal(row, setIndex, 'tool')">
                        <button class="btn btn-xs line-2" @click="openSelectModal(row, setIndex, 'tool')">선택</button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="td-box">
                      <input type="text" class="form-control" v-model="set.currentSafety" placeholder="현재 안전보건조치">
                    </div>
                  </td>
                  <td style="vertical-align:middle;">
                    <div class="td-box" style="display:flex;align-items:center;gap:6px;">
                      <Dropdown v-model="set.riskLevel"
                                :append-to-body="true"
                                :datasource="riskLevelOptions"
                                displayName="label"
                                valueName="value"
                                :isSelectionFirstData="false"
                                :width="70"/>
                      <span v-if="set.riskLevel" class="wp-risk-badge" :class="'wp-risk-badge-' + getRiskLevelKey(set.riskLevel)">{{ set.riskLevel }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="td-box">
                      <input type="text" class="form-control"
                        :class="{ 'is-invalid': isAdditionalSafetyRequired(set) }"
                        v-model="set.additionalSafety"
                        :placeholder="isAdditionalSafetyRequired(set) ? '위험도 상/중 - 필수 입력' : '추가 안전보건 조치'">
                    </div>
                  </td>
                  <td style="vertical-align:middle; text-align:center; white-space:nowrap;">
                    <button v-if="setIndex === 0" class="btn btn-xs light-blue mr-3" @click="addSet(row)">추가</button>
                    <button class="btn btn-xs line-2" @click="removeSet(row, setIndex)" :disabled="row.sets.length === 1">삭제</button>
                  </td>
                </tr>
              </template>
            </tbody>
            </table>
            </div>

            <div class="mt-20" style="font-weight:600;">■ 위험성 수준 및 판단 기준 예시</div>
            <table class="wp-risk-guide-table">
              <colgroup>
                <col style="width:80px;">
                <col style="width:90px;">
                <col>
                <col style="width:120px;">
                <col style="width:200px;">
              </colgroup>
              <thead>
                <tr>
                  <th colspan="2">위험성 수준</th>
                  <th>판단 기준</th>
                  <th>허용 가능 여부</th>
                  <th>TO DO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="risk-level-cell"><span class="wp-risk-badge wp-risk-badge-high">상</span></td>
                  <td style="text-align:center;">매우 높음</td>
                  <td>- 사고 발생 시 사망 또는 장애가 남을 수 있는 위험<br>- 산업안전보건법에 따른 기준을 만족하지 못하는 경우</td>
                  <td rowspan="2" style="text-align:center;">허용 불가능</td>
                  <td rowspan="2" style="text-align:center;">추가 안전보건조치 작성</td>
                </tr>
                <tr>
                  <td class="risk-level-cell"><span class="wp-risk-badge wp-risk-badge-mid">중</span></td>
                  <td style="text-align:center;">보통</td>
                  <td>- 사고 발생 시 요양이 필요한 위험<br>- 아차사고 사례가 있는 경우</td>
                </tr>
                <tr>
                  <td class="risk-level-cell"><span class="wp-risk-badge wp-risk-badge-low">하</span></td>
                  <td style="text-align:center;">매우 낮음</td>
                  <td>- 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우</td>
                  <td style="text-align:center;">허용 가능</td>
                  <td style="text-align:center;">현재의 안전보건조치 이행</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="box mt-30">
        <div class="box-header">
          <h3>고위험 작업계획</h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span>고위험 작업허가대상</span>
            </label>
            <div class="col-10 pt-2">
              <div class="wp-risk-grid">
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="고소작업"
                      :disabled="heavyWorkTypes.some(t => ['차량형 고소작업대','시저형 고소작업대'].includes(t))">
                    <i class="blue"></i>고소작업
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['고소작업'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="화기작업">
                    <i class="blue"></i>화기작업
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['화기작업'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="밀폐공간">
                    <i class="blue"></i>밀폐공간
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['밀폐공간'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="화학물질">
                    <i class="blue"></i>화학물질
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['화학물질'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="전기작업">
                    <i class="blue"></i>전기작업
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['전기작업'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="중량물취급"
                      :disabled="heavyWorkTypes.some(t => ['지게차','이동식크레인작업','차량계하역운반기계'].includes(t))
                        || (heavyWorkTypes.includes('굴착작업') && excavationPermit.hasHeavyCargo)
                        || (heavyWorkTypes.includes('차량계건설기계 작업') && constrEquipPermit.hasHeavyCargo)">
                    <i class="blue"></i>중량물취급
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['중량물취급'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="highRiskTargets" value="운전중작업">
                    <i class="blue"></i>운전중작업
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['운전중작업'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
              </div>

              <div class="mt-10">
                <div class="risk-item">
                  <label class="md-check">
                    <input type="checkbox" v-model="isHeavyWork"
                      :disabled="highAltitudePermit.workTypes.some(t => ['차량형 고소작업대','시저형 고소작업대'].includes(t))">
                    <i class="blue"></i>중장비 작업
                  </label>
                  <span class="risk-tooltip-btn" v-tooltip.top="{ content: riskTooltips['중장비작업'], classes: ['wp-risk-tooltip'] }">?</span>
                </div>
                <div class="wp-risk-sub" v-if="isHeavyWork">
                  <label class="md-check mr-15" v-for="(item, index) in heavyWorkOptions" :key="'heavy-work-' + index">
                    <input type="checkbox" v-model="heavyWorkTypes" :value="item">
                    <i class="blue"></i>{{ item }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span>설명</span>
            </label>
            <div class="col-10 pt-2">
              <a class="btn btn-md line-2 mr-10" :href="heavyEquipmentPdf" download>중장비 종류</a>
              <a class="btn btn-md line-2" :href="confinedSpacePdf" download>데이터센터 밀폐공간 현황</a>
            </div>
          </div>

          <div v-if="activeHighRiskTabs.length" class="mt-20">
            <ul class="nav nav-tabs wp-hr-tabs">
              <li class="nav-item" v-for="tab in activeHighRiskTabs" :key="tab.key">
                <a href="" :class="{ active: activeHighRiskTab === tab.key }"
                   @click.prevent="activeHighRiskTab = tab.key">{{ tab.label }}</a>
              </li>
            </ul>

            <div class="wp-hr-tab-content">

              <!-- 굴착작업 허가서 -->
              <ExcavationPermit v-if="activeHighRiskTab === '굴착작업'"
                :permit="excavationPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-lifting="loadLiftingFromHeavyLift('excavationPermit')"
                @load-cargo="loadCargoFromHeavyLift('excavationPermit')"
                @load-operators="loadOperatorsFromHeavyLift('excavationPermit')"
                @load-guides="loadGuidesFromHeavyLift('excavationPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('excavationPermit')"
                @load-procedures="loadProceduresInto('excavationPermit')"
              />


              <!-- 화기작업 허가서 -->
              <FireWorkPermit v-if="activeHighRiskTab === '화기작업'"
                :permit="fireWorkPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
              />
              <HighAltitudePermit v-if="activeHighRiskTab === '고소작업'"
                :permit="highAltitudePermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
              />
              <ConfinedSpacePermit v-if="activeHighRiskTab === '밀폐공간'"
                :permit="confinedSpacePermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
              />
              <ElectricWorkPermit v-if="activeHighRiskTab === '전기작업'"
                :permit="electricWorkPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                @load-procedures="loadProceduresInto('electricWorkPermit')"
              />
              <HeavyLiftPermit v-if="activeHighRiskTab === '중량물취급'"
                :permit="heavyLiftPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                @load-procedures="loadProceduresInto('heavyLiftPermit')"
              />
              <ChemicalPermit v-if="activeHighRiskTab === '화학물질'"
                :permit="chemicalPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
              />
              <DrivingWorkPermit v-if="activeHighRiskTab === '운전중작업'"
                :permit="operatingWorkPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
              />
              <CargoEquipPermit v-if="activeHighRiskTab === '차량계하역운반기계'"
                :permit="cargoEquipPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-lifting="loadLiftingFromHeavyLift('cargoEquipPermit')"
                @load-cargo="loadCargoFromHeavyLift('cargoEquipPermit')"
                @load-operators="loadOperatorsFromHeavyLift('cargoEquipPermit')"
                @load-guides="loadGuidesFromHeavyLift('cargoEquipPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('cargoEquipPermit')"
                @load-procedures="loadProceduresInto('cargoEquipPermit')"
              />

              <!-- 이동식크레인작업 허가서 -->
              <MobileCranePermit v-if="activeHighRiskTab === '이동식크레인작업'"
                :permit="mobileCranePermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-lifting="loadLiftingFromHeavyLift('mobileCranePermit')"
                @load-cargo="loadCargoFromHeavyLift('mobileCranePermit')"
                @load-operators="loadOperatorsFromHeavyLift('mobileCranePermit')"
                @load-guides="loadGuidesFromHeavyLift('mobileCranePermit')"
                @load-equipment="loadEquipmentFromHeavyLift('mobileCranePermit')"
                @load-procedures="loadProceduresInto('mobileCranePermit')"
              />

              <!-- 차량계건설기계 작업 허가서 -->
              <ConstrEquipPermit v-if="activeHighRiskTab === '차량계건설기계 작업'"
                :permit="constrEquipPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-cargo="loadCargoFromHeavyLift('constrEquipPermit')"
                @load-operators="loadOperatorsFromHeavyLift('constrEquipPermit')"
                @load-guides="loadGuidesFromHeavyLift('constrEquipPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('constrEquipPermit')"
                @load-procedures="loadProceduresInto('constrEquipPermit')"
              />

              <!-- 지게차 허가서 -->
              <ForkliftPermit v-if="activeHighRiskTab === '지게차'"
                :permit="forkliftPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-operators="loadOperatorsFromHeavyLift('forkliftPermit')"
                @load-guides="loadGuidesFromHeavyLift('forkliftPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('forkliftPermit')"
                @load-cargo="loadForkliftCargoFromHeavyLift()"
                @load-procedures="loadProceduresInto('forkliftPermit')"
              />

              <!-- 차량형 고소작업대 허가서 -->
              <BoomLiftPermit v-if="activeHighRiskTab === '차량형 고소작업대'"
                :permit="boomLiftPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-operators="loadOperatorsFromHeavyLift('boomLiftPermit')"
                @load-guides="loadGuidesFromHeavyLift('boomLiftPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('boomLiftPermit')"
                @load-procedures="loadProceduresInto('boomLiftPermit')"
              />

              <!-- 시저형 고소작업대 허가서 -->
              <ScissorLiftPermit v-if="activeHighRiskTab === '시저형 고소작업대'"
                :permit="scissorLiftPermit"
                :schedule-date-disabled-fn="scheduleDateDisabledFn"
                :signal-method-options="signalMethodOptions"
                @load-operators="loadOperatorsFromHeavyLift('scissorLiftPermit')"
                @load-guides="loadGuidesFromHeavyLift('scissorLiftPermit')"
                @load-equipment="loadEquipmentFromHeavyLift('scissorLiftPermit')"
                @load-procedures="loadProceduresInto('scissorLiftPermit')"
              />

              <!-- 나머지 탭 placeholder -->
              <div v-if="activeHighRiskTab && !['화기작업','고소작업','밀폐공간','전기작업','중량물취급','화학물질','운전중작업','굴착작업','차량계하역운반기계','이동식크레인작업','차량계건설기계 작업','지게차','차량형 고소작업대','시저형 고소작업대'].includes(activeHighRiskTab)" class="wp-hr-tab-placeholder">
                <p class="text-888">[ {{ activeHighRiskTab }} ] 세부 작업 계획서 / 허가서 작성 영역입니다.</p>
              </div>


            </div><!-- end wp-hr-tab-content -->
          </div><!-- end activeHighRiskTabs -->
        </div>
      </div>
      <div class="box mt-30">
        <div class="box-header">
          <h3>서류업로드</h3>
        </div>
        <div class="box-body">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">산재보험가입증명서</span>
            </label>
            <div class="col-10 pt-2">
              <input type="file" @change="handleInsuranceFile">
              <div class="text-888 mt-5">
                (필수) 산재 보험 가입 증명원은 공사장명이 나오도록 발급받으세요 <br />
                공사장명이 나온 산재 보험 가입 증명원 제출이 어려운 경우, 본사의 산재보험가입증명원을 첨부하세요.
              </div>
              <div class="mt-10" v-if="insuranceFile">
                {{ insuranceFile.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap mt-30 justify-content-center">
        <button class="btn btn-lg line-2" @click="goToPermitAgree">
          <i class="icon-arrow-line-left mr-5"></i>이전
        </button>
        <button class="btn btn-lg blue" @click="goToPermitCheck">
          다음<i class="icon-arrow-line-right ml-5"></i>
        </button>
      </div>
    </div>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue';
import { refreshFlowToken } from '@/services/flowToken';
import * as XLSX from 'xlsx';
import ExcavationPermit from './components/ExcavationPermit.vue';
import FireWorkPermit from './components/FireWorkPermit.vue';
import HighAltitudePermit from './components/HighAltitudePermit.vue';
import ConfinedSpacePermit from './components/ConfinedSpacePermit.vue';
import ElectricWorkPermit from './components/ElectricWorkPermit.vue';
import HeavyLiftPermit from './components/HeavyLiftPermit.vue';
import ChemicalPermit from './components/ChemicalPermit.vue';
import DrivingWorkPermit from './components/DrivingWorkPermit.vue';
import CargoEquipPermit from './components/CargoEquipPermit.vue';
import MobileCranePermit from './components/MobileCranePermit.vue';
import ConstrEquipPermit from './components/ConstrEquipPermit.vue';
import ForkliftPermit from './components/ForkliftPermit.vue';
import BoomLiftPermit from './components/BoomLiftPermit.vue';
import ScissorLiftPermit from './components/ScissorLiftPermit.vue';

export default {
  components: {
    Dropdown,
    ExcavationPermit,
    FireWorkPermit,
    HighAltitudePermit,
    ConfinedSpacePermit,
    ElectricWorkPermit,
    HeavyLiftPermit,
    ChemicalPermit,
    DrivingWorkPermit,
    CargoEquipPermit,
    MobileCranePermit,
    ConstrEquipPermit,
    ForkliftPermit,
    BoomLiftPermit,
    ScissorLiftPermit
  },
  // docFileUploadMixin 이 활성 planId 를 inject 로 얻어 BE 업로드 호출에 사용
  provide() {
    const self = this;
    return {
      workPermitPlanId: () => self.planId
    };
  },
  data() {
    return {
      planId: '',
      planDateRange: null,
      pendingRangeStart: null,
      planName: '',
      companyName: '',
      workManager: '',
      workManagerPhone: '',
      workPeopleCount: null,
      safetyManager: '',
      safetyManagerPhone: '',
      locationDetail: '',
      activeHighRiskTab: null,
      // 이전 허가서 불러오기 모달 상태
      showLoadModal: false,
      loadForm: { ordererName: '', ordererEmail: '', managerName: '', planId: '' },
      loadResults: [],
      loadSearching: false,
      loadSearched: false,
      excavationPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, insuranceName: '', modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceExpiry: '', driveType: '', speedLimit: '', equipWeight: '', turningRadius: '', ratedLoad: '', maxLiftHeight: '', boomMaxHeight: '', boomLength: '', regularInspectionDate: '', inspectionExpiry: '', workDevices: [], workDeviceOther: false, workDeviceOtherText: '' }],
        siteInvestigation: {
          underground: [
            { name: '도시가스', applicable: false, measure: '' },
            { name: '통신선', applicable: false, measure: '' },
            { name: '전기', applicable: false, measure: '' },
            { name: '상하수도', applicable: false, measure: '' },
            { name: '기타', applicable: false, measure: '' }
          ],
          groundTypes: [], groundTypeOther: false, groundTypeOtherText: '',
          slopeCheck: false, slopeText: '',
          conditions: [],
          specialNoteCheck: false, specialNoteText: '',
          groundwaterStatus: '', groundwaterMeasure: '',
          requiredLoadCapacity: '', actualLoadCapacity: '',
          reinforcementMethods: [], reinforcementOther: false, reinforcementOtherText: '',
          accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '',
          nearbyPowerLines: '', nearbyPowerLinesMeasure: '',
          nearbyObstacle: '', nearbyObstacleMeasure: ''
        },
        hasLifting: false,
        liftingList: [{ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' }],
        hasHeavyCargo: false,
        cargoList: [{ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' }],
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'cert', label: '건설기계 등록·검사증', checked: false, files: [] },
          { key: 'license', label: '운전원 자격·면허 사본', checked: false, files: [] },
          { key: 'manual', label: '제조·임대사 사용 설명서', checked: false, files: [] },
          { key: 'liftcap', label: '인양능력표', checked: false, files: [] },
          { key: 'workradius', label: '작업반경도(높이별 작업반경)', checked: false, files: [] },
          { key: 'rental', label: '기계 대여사항 기록부', checked: false, files: [] },
          { key: 'repair', label: '건설기계 수리·보수·점검이력', checked: false, files: [] }
        ]
      },
      cargoEquipPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', vehicleGrossWeight: '', speedLimit: '', climbingAbility: '', maxSpeed: '', loadCapacity: '', loadSize: '', dumpMaxTiltAngle: '', dumpLiftTime: '', regularInspectionDate: '', inspectionExpiry: '' }],
        hasRigging: false,
        liftingList: [{ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' }],
        hasHeavyCargo: true,
        cargoList: [{ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' }],
        siteInvestigation: {
          groundTypes: [], groundTypeOther: false, groundTypeOtherText: '',
          slopeCheck: false, slopeText: '',
          conditions: [],
          specialNoteCheck: false, specialNoteText: '',
          reinforcementMethods: [], reinforcementOther: false, reinforcementOtherText: '',
          accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '',
          nearbyPowerLines: '', nearbyPowerLinesMeasure: '',
          nearbyObstacle: '', nearbyObstacleMeasure: ''
        },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'insurance', label: '기계가입 보험증서', checked: false, files: [] },
          { key: 'license', label: '운전원 면허증 사본', checked: false, files: [] }
        ]
      },
      mobileCranePermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{
          id: Date.now(),
          equipType: '카고크레인',
          hasCertificate: null,
          insuranceStatus: '', insuranceName: '', insuranceExpiry: '',
          regularInspectionDate: '', inspectionExpiry: '',
          vehicleRegNo: '', vehicleType: '', vehicleName: '', modelTypeYear: '',
          modificationDate: '', modificationCompany: '',
          craneType: '', outriggerWidth: '',
          maxWorkHeight: '', maxWorkRadius: '', ratedLoad: '',
          inspectionAgency: '', operationMethods: [],
          machineName: '', registrationNo: '', machineSpec: '',
          manufactureYear: '', manufacturer: '',
          length: '', width: '', height: '', driveType: '',
          standardBoomRadius: '', boomLengthMax: '', boomMaxAngle: '',
          maxRatedLoad: '', boomMinAngle: '', minRatedLoad: '',
          hookMaxHeight: '', outriggerSize: ''
        }],
        hasRigging: true,
        liftingList: [{ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' }],
        hasHeavyCargo: true,
        cargoList: [{ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' }],
        siteInvestigation: { groundTypes: [], groundTypeOther: false, groundTypeOtherText: '', conditions: [], slopeCheck: false, slopeText: '', specialNoteCheck: false, specialNoteText: '', reinforcementMethods: [], reinforcementOther: false, reinforcementOtherText: '', accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '', nearbyPowerLines: '', nearbyPowerLinesMeasure: '', nearbyObstacle: '', nearbyObstacleMeasure: '' },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'carReg', label: '자동차등록증(카고크레인)', checked: false, files: [] },
          { key: 'cargoSafety', label: '안전검사·인증합격증(카고크레인)', checked: false, files: [] },
          { key: 'constrCert', label: '건설기계 등록·검사증(하이드로크레인)', checked: false, files: [] },
          { key: 'license', label: '운전원 자격·면허 사본', checked: false, files: [] },
          { key: 'manual', label: '제조·임대사 사용설명서', checked: false, files: [] },
          { key: 'liftcap', label: '인양하중표(아웃트리거 슬라이드 길이에 따른 작업반경)', checked: false, files: [] },
          { key: 'ndt', label: '선회부 비파괴검사 자료 등', checked: false, files: [] }
        ]
      },
      constrEquipPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', machineSpec: '', driveType: '', otherSpec: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', regularInspectionDate: '', inspectionExpiry: '' }],
        hasHeavyCargo: false,
        cargoList: [{ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' }],
        siteInvestigation: { groundTypes: [], groundTypeOther: false, groundTypeOtherText: '', conditions: [], slopeCheck: false, slopeText: '', specialNoteCheck: false, specialNoteText: '', reinforcementMethods: [], reinforcementOther: false, reinforcementOtherText: '', accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '', nearbyPowerLines: '', nearbyPowerLinesMeasure: '', nearbyObstacle: '', nearbyObstacleMeasure: '' },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'insurance', label: '기계가입 보험증서', checked: false, files: [] },
          { key: 'license', label: '운전원 면허증 사본', checked: false, files: [] }
        ]
      },
      forkliftPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', machineSpec: '', driveType: '', equipWeight: '', maxSpeed: '', mastAngle: '', mastHeight: '', regularInspectionDate: '', inspectionExpiry: '' }],
        siteInvestigation: {
          groundTypes: [], groundTypeOther: false, groundTypeOtherText: '',
          slopeCheck: false, slopeText: '',
          conditions: [],
          specialNoteCheck: false, specialNoteText: '',
          groundwaterStatus: '', groundwaterMeasure: '',
          requiredLoadCapacity: '', actualLoadCapacity: '',
          reinforcementMethods: [], reinforcementOther: false, reinforcementOtherText: '',
          accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '',
          workerEntryCheck: '', workerEntryMeasure: '',
          roadCollapseCheck: '', roadCollapseMeasure: '',
          nearbyObstacle: '', nearbyObstacleMeasure: ''
        },
        cargoAndLoad: {
          forkliftCapacity: '',
          cargo: { name: '', unitWeight: '', type: '', shape: '', size: '', qtyPerTrip: '', weightPerTrip: '', totalQty: '', totalWeight: '' },
          loading: { stackHeight: '', minPathHeight: '', stackWidth: '', minPathWidth: '', driverVisibility: '', requiredRadius: '' }
        },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'cert', label: '건설기계 등록·검사증', checked: false, files: [] },
          { key: 'license', label: '운전원 자격·면허 사본', checked: false, files: [] },
          { key: 'manual', label: '제조·임대사 사용설명서', checked: false, files: [] },
          { key: 'rental', label: '기계 대여사항 기록부', checked: false, files: [] },
          { key: 'repair', label: '건설기계 수리·보수·점검이력 등', checked: false, files: [] }
        ]
      },
      boomLiftPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, registrationNo: '', vehicleType: '', vehicleName: '', modelYear: '', manufacturer: '', manufactureDate: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', maxWorkHeight: '', workType: '', maxWorkRadius: '', platformSpec: '', ratedLoad: '', maxWindSpeed: '', safetyInspectionDate: '' }],
        siteInvestigation: {
          outriggerConditions: [], outriggerSlopeCheck: false, outriggerSlopeText: '',
          outriggerSpecialCheck: false, outriggerSpecialText: '',
          outriggerReinforcements: [], outriggerReinforcementOther: false, outriggerReinforcementOtherText: '',
          accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '',
          obstacleCheck: '', obstacleMeasure: ''
        },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'carReg', label: '자동차등록증', checked: false, files: [] },
          { key: 'safetyCert', label: '안전인증 사본', checked: false, files: [] },
          { key: 'safetyInspection', label: '안전검사 사본', checked: false, files: [] },
          { key: 'license', label: '운전원 자격·면허 사본', checked: false, files: [] },
          { key: 'manual', label: '제조·임대社 사용설명서', checked: false, files: [] },
          { key: 'workRadius', label: '작업반경표(아웃트리거 슬라이드 길이에 따른 작업 반경)', checked: false, files: [] },
          { key: 'ndt', label: '선회부 비파괴검사 자료 등', checked: false, files: [] }
        ]
      },
      scissorLiftPermit: {
        workPeriod: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, manufacturer: '', modelNo: '', serialNo: '', manufactureYear: '', safetyCertDate: '', maxWorkHeight: '', ratedLoad: '', platformSpec: '', maxOccupancy: '', maxSlope: '', maxWindSpeed: '' }],
        siteInvestigation: {
          groundConditions: [], slopeCheck: false, slopeText: '',
          specialNoteCheck: false, specialNoteText: '',
          accessRestrictions: [], accessRestrictionOther: false, accessRestrictionOtherText: '',
          obstacleCheck: '', obstacleMeasure: ''
        },
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachmentDocs: [
          { key: 'safetyCert', label: '안전인증 사본(합격증)', checked: false, files: [], required: true },
          { key: 'equipHistory', label: '장비이력(수리내역 포함) 관리카드', checked: false, files: [] },
          { key: 'manual', label: '제조·임대社 사용설명서', checked: false, files: [] }
        ]
      },
      fireWorkPermit: {
        workPeriod: [],
        workTypes: [],
        isOther: false,
        otherText: '',
        fireWatcher: '',
        fireWatcherPhone: ''
      },
      highAltitudePermit: {
        workPeriod: [],
        workTypes: [],
        isOther: false,
        otherText: ''
      },
      confinedSpacePermit: {
        workPeriod: [],
        spaceTypes: [],
        isOther: false,
        otherText: ''
      },
      electricWorkPermit: {
        workDate: '',
        liveLineWork: '해당없음',
        workPeriod: [],
        workScope: '',
        workers: [{ name: '', qualification: '' }],
        approachDistance: '',
        protections: [],
        isProtectionOther: false,
        protectionOtherText: '',
        measurementEquip: '',
        liveLineEquip: '',
        defenseEquip: '',
        otherEquip: '',
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }],
        attachments: {
          facility: [],
          facilityOther: false,
          facilityOtherText: '',
          safety: [],
          safetyOther: false,
          safetyOtherText: '',
          files: {}
        }
      },
      chemicalPermit: {
        workPeriod: [],
        chemicals: [{ checked: false, id: Date.now(), name: '', handlingMethods: '', hazard: '', msdsFiles: [] }]
      },
      operatingWorkPermit: {
        workPeriod: [],
        facilities: [{ checked: false, id: Date.now(), facilityName: '', workScope: '', workContent: '' }]
      },
      heavyLiftPermit: {
        workPeriod: [],
        transportMethods: [],
        operators: [{ name: '', license: '', phone: '' }],
        guides: [{ name: '', signalMethods: [], phone: '', wirelessMeans: '' }],
        equipmentList: [{ id: Date.now(), hasCertificate: null, modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', regularInspectionDate: '', inspectionExpiry: '', capacity: '', workRadius: '', transport: '' }],
        liftingList: [{ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' }],
        cargoList: [{ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' }],
        procedures: [{ item: '', procedure: '', riskFactor: '', hazard: '', currentMeasure: '', riskLevel: '', additionalMeasure: '' }]
      },
      highRiskTargets: [],
      isHeavyWork: false,
      heavyWorkOptions: ['굴착작업', '차량계하역운반기계', '이동식크레인작업', '차량계건설기계 작업', '지게차', '차량형 고소작업대', '시저형 고소작업대'],
      heavyWorkTypes: [],
      heavyEquipmentPdf: '/pdf/Appendix. 중장비 작업계획서 대상.pdf',
      confinedSpacePdf: '/pdf/Appendix. 밀폐공간 현황.pdf',
      riskTooltips: {
        고소작업: '높이 또는 깊이 2m 이상의 추락위험이 있는 장소에서의 작업이나 높이가 2m미만이나 고열물, 강산 등 위험물 상부에서 행하는 작업',
        화기작업: '용접, 용단, 연마, 드릴 등 화염 또는 스파크를 발생시키는 작업 또는 가연성물질의 점화원이 될 수 있는 모든 기기를 사용하는 작업',
        밀폐공간: '탱크, 맨홀 및 시설의 내부 등 산소결핍, 유해물질 중독 또는 유해가스로 인한 화재, 폭발 등의 위험이 있는 장소에서 하는 작업',
        화학물질: '화학물질을 취급하여 하는 작업이나 위험물 등이 존재하는 설비나 탱크, 배관 등의 점검, 수리, 해체를 할 때 내용물의 배출 등 위험요인이 존재하는 작업',
        전기작업: '감전위험이 있는 전기설비(기계·기구) 또는 전로의 설치·해체·정비·점검 등의 작업 중 해당 전압이 50볼트 또는 전기에너지가 250볼트암페어를 넘는 작업',
        중량물취급: '직접 들어올리거나 운반하기 어려운 물건을 중량물이라고 하며, 이 중량물을 이동시키거나 취급하는 작업',
        운전중작업: '기계·설비·장비 등이 가동(운전)되고 있는 상태에서 근로자가 해당 장비를 조작하거나 유지·보수하는 작업',
        중장비작업: '차량계 하역운반기계, 차량계 건설기계, 양중기 등을 사용하여 굴착, 양중, 수리, 점검 등을 수행하는 작업',
      },
      idcList: [],
      selectedIdcCode: null,
      selectedFloorKeys: [],
      scheduleRows: [this.createScheduleRow()],
      scheduleTimelineColors: ['#2F80ED', '#27AE60', '#F2C94C', '#EB5757', '#9B51E0'],
      rows: [this.createRow()],
      riskLevelOptions: [
        { label: '상', value: '상' },
        { label: '중', value: '중' },
        { label: '하', value: '하' }
      ],
      hazardOptions: [
        { key: '끼임', name: '끼임', description: '신체 일부가 기계·설비 구동부 사이에 끼이는 위험', ex: '시저형 고소작업대와 상부 보 사이에 작업자가 끼임' },
        { key: '감김·말림', name: '감김·말림', description: '회전하는 물체에 장갑, 옷 등이 말려들어가는 위험', ex: '앙카드릴에 장갑이 말림' },
        { key: '절단/베임/찔림', name: '절단/베임/찔림', description: '날카로운 물체에 의해 신체가 베이거나 찔리는 것', ex: '칼 등에 베임, 못에 찔림' },
        { key: '부딪힘', name: '부딪힘', description: '고정물 또는 이동체와 충돌하는 위험', ex: '지게차에 보행자가 부딪힘' },
        { key: '맞음', name: '맞음', description: '위에서 떨어지는 물체(낙하물)나 가공 중 튕겨 나간 파편(비래)에 맞는 위험', ex: '상부 작업자가 떨어트린 공구에 하부 작업자가 맞음' },
        { key: '무너짐', name: '무너짐', description: '건축물, 쌓아 올린 화물, 토사, 적재물 등이 무너져 내리며 사람을 덮치는 것', ex: '화물차에 적재된 자재가 무너짐' },
        { key: '깔림', name: '깔림', description: '무거운 물체가 넘어져 그 아래에 사람이 깔리는 것', ex: '랙이 전도하여 사람이 깔림' },
        { key: '떨어짐', name: '떨어짐', description: '사람이 높은 곳(비계, 사다리, 지붕 등)에서 아래로 떨어지는 위험', ex: '사다리 승강 중 발을 헛디뎌서 떨어짐' },
        { key: '넘어짐', name: '넘어짐', description: '사람 또는 물건이 미끄러지거나 걸려 넘어지는 위험', ex: '이동 중 전선 등에 걸려 넘어짐' },
        { key: '감전', name: '감전', description: '충전부(전기가 흐르는 곳)에 직접 닿거나 누전된 금속체에 닿아 인체에 전류가 흐르는 위험', ex: '전기 작업 중 활선에 접촉하여 감전, 수조 청소를 위하여 강제배수용 수중펌프 설치 중 수중펌프 누전으로 감전' },
        { key: '아크', name: '아크', description: '공기를 매개로 한 전기 방전으로, 고열과 압력파를 통해 화상 및 화재를 일으키는 위험', ex: '배전반 전압 측정 중 리드봉이 다른 상의 버스바(Busbar)에 가까워지면서 아크플래시 발생' },
        { key: '폭발·파열', name: '폭발·파열', description: '압력의 급격한 방출이나 화학 반응으로 인해 용기(압력용기)나 배관 등이 터지는 위험', ex: '냉동기 이상압력으로 배관 이음부 폭발 발생' },
        { key: '화재·폭발', name: '화재·폭발', description: '인화성 물질에 불이 붙어 확산되는 것', ex: '경유 저장소 내 경유 주입 중 정전기로 화재 발생' },
        { key: '화상', name: '화상', description: '고온·스팀·복사열·화학물질 등에 의한 신체 손상', ex: '보일러 고온부 접촉' },
        { key: '이상기압', name: '이상기압', description: '고기압(잠수 작업)이나 저기압 환경에 노출되어 발생하는 위험', ex: '' },
        { key: '소음', name: '소음', description: '강한 소음 노출 또는 장시간 소음 노출 작업으로 청력 손상 위험', ex: '서버실 내 장시간 작업' },
        { key: '진동', name: '진동', description: '진동이 발생하는 공구 사용 등', ex: '장기간 진동 공구 사용으로 혈관, 신경 등 이상 발생' },
        { key: '온열질환 우려', name: '온열질환 우려', description: '고온 환경에 장시간 노출되거나 강한 육체노동으로 인해 체온 조절 기능이 무너지면서 온열질환이 발생할 수 있는 위험 (열사병, 열탈진, 열경련, 열실신, 열발진 등)', ex: '여름철 옥외작업 등' },
        { key: '한랭질환 우려', name: '한랭질환 우려', description: '추운 환경에 장시간 노출되어 체온이 비정상적으로 낮아지거나 신체 일부 조직이 손상되는 한랭질환이 발생할 수 있는 위험 (저체온증, 동상, 동창 등)', ex: '겨울철 옥외작업, 냉동창고 작업 등' },
        { key: '화학물질 노출·비산', name: '화학물질 노출·비산', description: '화학물질(유해가스, 증기, 분진 등)을 흡입하거나 피부로 흡수 위험', ex: '에폭시 작업 중 환기 불충분으로 에폭시 가스 노출' },
        { key: '중독', name: '중독', description: '유해 화학물질이 흡입·섭취·피부흡수 등을 통해 체내에 들어가 건강장해를 일으키는 위험', ex: '빈병에 담긴 화학물질을 음용하여 사고' },
        { key: '질식', name: '질식', description: '산소 부족 또는 유해가스에 의해 정상적인 호흡이 어려워지는 위험', ex: '밀폐공간 작업' },
        { key: '산소결핍', name: '산소결핍', description: '불활성가스 사용 등으로 공기 중 산소 농도가 낮아지는 위험', ex: '옥내 저장탱크 질소 퍼지 작업' },
        { key: '부식', name: '부식', description: '산·알칼리 등의 화학물질이 피부·눈·금속 등을 손상시키는 위험', ex: '' },
        { key: '환경오염', name: '환경오염', description: '화학물질이 외부로 유출되어 토양·수질·대기를 오염시키는 위험', ex: '화학물질이 다량 누액하여 배수로에 흘러들어감' },
        { key: '방사선 노출', name: '방사선 노출', description: '비파괴 검사나 방사선 설비 작업 중 방사선에 노출될 수 있는 위험', ex: '방사선 설비 인터락 기능 off 후 유지보수 작업하여 방사선에 피폭' },
        { key: '유해광선 노출', name: '유해광선 노출', description: '용접광 등 유해한 빛에 노출되는 위험', ex: '용접 작업' },
        { key: '근골격계 부담', name: '근골격계 부담', description: '반복작업·중량물 취급 등으로 신체 부담 발생', ex: '중량물 반복 이동 작업' }
      ],
      protectionOptions: [
        { key: '머리|안전모', category: '머리', name: '안전모' },
        { key: '눈|보안경', category: '눈', name: '보안경' },
        { key: '눈|차광보안경', category: '눈', name: '차광보안경' },
        { key: '얼굴|안면보호구', category: '얼굴', name: '안면보호구' },
        { key: '귀|귀마개', category: '귀', name: '귀마개' },
        { key: '귀|귀덮개', category: '귀', name: '귀덮개' },
        { key: '호흡기|방진마스크', category: '호흡기', name: '방진마스크' },
        { key: '호흡기|방독마스크', category: '호흡기', name: '방독마스크' },
        { key: '호흡기|송기마스크', category: '호흡기', name: '송기마스크' },
        { key: '호흡기|공기호흡기', category: '호흡기', name: '공기호흡기' },
        { key: '손|안전장갑', category: '손', name: '안전장갑' },
        { key: '손|절연장갑', category: '손', name: '절연장갑' },
        { key: '손|내화학장갑', category: '손', name: '내화학장갑' },
        { key: '손|방열장갑', category: '손', name: '방열장갑' },
        { key: '손|절단방지장갑', category: '손', name: '절단방지장갑' },
        { key: '손|방진장갑', category: '손', name: '방진장갑' },
        { key: '발|안전화', category: '발', name: '안전화' },
        { key: '발|안전장화', category: '발', name: '안전장화' },
        { key: '발|절연화', category: '발', name: '절연화' },
        { key: '발|절연장화', category: '발', name: '절연장화' },
        { key: '몸통|작업복', category: '몸통', name: '작업복' },
        { key: '몸통|방열복', category: '몸통', name: '방열복' },
        { key: '몸통|내화학복', category: '몸통', name: '내화학복' },
        { key: '몸통|Arc suit', category: '몸통', name: 'Arc suit' },
        { key: '몸통|안전그네식 안전대', category: '몸통', name: '안전그네식 안전대' },
        { key: '몸통|벨트식 안전대', category: '몸통', name: '벨트식 안전대' }
      ],
      toolOptions: [
        { key: '전기작업선', name: '전기작업선', description: '' },
        { key: '이동식 분전반', name: '이동식 분전반', description: '' },
        { key: '이동식 콘센트함', name: '이동식 콘센트함', description: '' },
        { key: '목재가공용 둥근톱', name: '목재가공용 둥근톱', description: '' },
        { key: '고속절단기', name: '고속절단기', description: '' },
        { key: '원형톱', name: '원형톱', description: '' },
        { key: '전동 체인 톱', name: '전동 체인 톱', description: '' },
        { key: '지그톱', name: '지그톱', description: '' },
        { key: '핸드그라인더', name: '핸드그라인더', description: '' },
        { key: '핸드그라인더(면갈이)', name: '핸드그라인더(면갈이)', description: '' },
        { key: '핸드커터', name: '핸드커터', description: '' },
        { key: '전동드릴', name: '전동드릴', description: '' },
        { key: '함마드릴', name: '함마드릴', description: '' },
        { key: '햄머(파쇄기)', name: '햄머(파쇄기)', description: '' },
        { key: '임팩트 렌치', name: '임팩트 렌치', description: '' },
        { key: '코어 드릴', name: '코어 드릴', description: '콘크리트벽 천공작업용' },
        { key: '대패용 전동기', name: '대패용 전동기', description: '각목, 목재 평면의 미려한 가공 및 마무리 작업용' },
        { key: '에어 콤프레셔', name: '에어 콤프레셔', description: '에어 건과 연결하여 내장, 뿜칠 등의 작업용' },
        { key: '에어 커터', name: '에어 커터', description: '인테리어 가구 및 내부 목재용품 작업용' },
        { key: '인버터 직류 아크용접기', name: '인버터 직류 아크용접기', description: '' },
        { key: '교류 아크용접기', name: '교류 아크용접기', description: '' },
        { key: '바이브레이터', name: '바이브레이터', description: '콘크리트 타설 작업시 진동을 주어 공극이 생기지 않도록 다짐작업용' },
        { key: '핸드카타', name: '핸드카타', description: '철근을 절단하는 공도구' },
        { key: '이동용 철근 절단기', name: '이동용 철근 절단기', description: '' },
        { key: '철근 절곡기', name: '철근 절곡기', description: '' },
        { key: '열풍기', name: '열풍기', description: '' },
        { key: '모터식 분무기', name: '모터식 분무기', description: '' },
        { key: '엔진 양수기', name: '엔진 양수기', description: '' },
        { key: '수중 양수기', name: '수중 양수기', description: '' },
        { key: '송풍기', name: '송풍기', description: '' },
        { key: '전기수중히터', name: '전기수중히터', description: '' },
        { key: '투광등', name: '투광등', description: '' },
        { key: '전등선', name: '전등선', description: '' },
        { key: '윈치', name: '윈치', description: '' },
        { key: '믹서기', name: '믹서기', description: '' },
        { key: '파이프머신', name: '파이프머신', description: '' },
        { key: '각도 절단기', name: '각도 절단기', description: '' },
        { key: '이동식 발전기', name: '이동식 발전기', description: '' },
        { key: '다짐기(램머)', name: '다짐기(램머)', description: '콘크리트 등 다짐용' },
        { key: '체인블럭', name: '체인블럭', description: '' },
        { key: '기타', name: '기타', description: '' }
      ],
      equipmentTypeOptions: ['지게차', '크레인', '집게차', '기타(컨베이어,리프트 등)'],
      equipmentTypes: [],
      equipmentStatusRows: [this.createEquipmentStatusRow()],
      workerRows: [this.createWorkerRow()],
      signalMethodOptions: ['수신호', '무선', '기타'],
      signalMethod: '',
      riskRows: [this.createRiskRow()],
      transportMap: '',
      mapPlaceholder: '* 중장비 중 이동이 예상 될 경우 출발지에서 목적지를 작성\n* 이동 경로 중 경사지가 있을 경우 별도 안전대책 수립',
      cargoRows: [this.createCargoRow()],
      layoutFiles: [],
      insuranceFile: null
    }
  },
  computed: {
    canSearchLoad() {
      const f = this.loadForm;
      // 문서번호(planId)는 선택 — 비우면 임시저장(이어작성) 조회
      return !!(f.ordererName && f.ordererName.trim()
        && f.ordererEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.ordererEmail.trim())
        && f.managerName && f.managerName.trim());
    },
    selectedIdc() {
      return this.idcList.find((item) => item.locationCode === this.selectedIdcCode) || null;
    },
    regionGroups() {
      // 안전작업 위치는 4 depth (IDC=구분 → 관 → 층 → 위치).
      // 기존 5-depth UI(region > building > floor > detail)에 맞추기 위해
      // 선택된 IDC 자체를 단일 region 으로 감싼다.
      if (!this.selectedIdc || !this.selectedIdc.children) return [];
      const buildings = (this.selectedIdc.children || []).filter((item) => item.isDeleteYN === 'N');
      const regionName = this.selectedIdc.locationName || '';
      const buildingGroups = buildings.map((building) => {
        const floors = (building.children || []).filter((item) => item.isDeleteYN === 'N');
        const rows = floors.map((floor) => {
          const floorKey = `${this.selectedIdc.locationCode}|${building.locationCode}|${floor.locationCode}`;
          const details = (floor.children || [])
            .filter((item) => item.isDeleteYN === 'N')
            .map((detail) => ({
              key: `${floorKey}|${detail.locationCode}`,
              detailName: detail.locationName
            }))
            // '기타' 는 층별 목록에서 항상 맨 뒤로 (그 외 순서는 원본 유지)
            .sort((a, b) => (a.detailName === '기타' ? 1 : 0) - (b.detailName === '기타' ? 1 : 0));
          return {
            key: floorKey,
            floorName: floor.locationName,
            details
          };
        });
        return {
          key: `${this.selectedIdc.locationCode}|${building.locationCode}`,
          buildingName: building.locationName,
          rows,
          isFirst: false
        };
      }).filter((group) => group.rows.length > 0);
      if (buildingGroups.length === 0) return [];
      buildingGroups[0].isFirst = true;
      const rowspan = buildingGroups.reduce((sum, building) => sum + building.rows.length, 0);
      return [{
        key: this.selectedIdc.locationCode,
        regionName,
        buildings: buildingGroups,
        rowspan
      }];
    },
    scheduleRegions() {
      // 일정 행의 "구분" 드롭다운은 선택된 IDC 한 개만 노출 (구분=IDC).
      if (!this.selectedIdc) return [];
      return [this.selectedIdc];
    },
    // 위 "작업 위치"에서 체크한 위치(selectedFloorKeys: idc|building|floor|detail)만
    // 공정표 위치 드롭박스에서 선택 가능하도록 허용 코드 집합 구성
    allowedScheduleLocations() {
      const buildings = new Set();
      const floors = new Set();   // "building|floor"
      const details = new Set();  // "building|floor|detail"
      (this.selectedFloorKeys || []).forEach((k) => {
        const parts = String(k).split('|');
        if (parts.length < 4) return;
        const b = parts[1], f = parts[2], d = parts[3];
        buildings.add(b);
        floors.add(b + '|' + f);
        details.add(b + '|' + f + '|' + d);
      });
      return { buildings, floors, details };
    },
    scheduleTimelineRange() {
      if (this.planDateRange && this.planDateRange.length === 2 && this.planDateRange[0] && this.planDateRange[1]) {
        return {
          start: new Date(this.planDateRange[0]),
          end: new Date(this.planDateRange[1])
        };
      }
      let minDate = null;
      let maxDate = null;
      this.scheduleRows.forEach((row) => {
        const start = this.parseDate(row.startDate);
        const end = this.parseDate(row.endDate);
        if (!start || !end) return;
        if (!minDate || start < minDate) minDate = start;
        if (!maxDate || end > maxDate) maxDate = end;
      });
      if (!minDate || !maxDate) return null;
      return { start: minDate, end: maxDate };
    },
    scheduleTimelineDays() {
      if (!this.scheduleTimelineRange) return [];
      const days = [];
      const start = new Date(this.scheduleTimelineRange.start);
      const end = new Date(this.scheduleTimelineRange.end);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      for (let current = new Date(start); current <= end; current.setDate(current.getDate() + 1)) {
        days.push({
          key: this.formatDate(current),
          day: current.getDate(),
          month: current.getMonth() + 1
        });
        if (days.length > 31) break;
      }
      return days;
    },
    scheduleTimelineLabel() {
      if (!this.scheduleTimelineRange) return '';
      const start = this.scheduleTimelineRange.start;
      const end = this.scheduleTimelineRange.end;
      const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
      if (sameMonth) {
        return `${start.getMonth() + 1}월`;
      }
      return `${start.getMonth() + 1}월 ${start.getDate()}일 ~ ${end.getMonth() + 1}월 ${end.getDate()}일`;
    },
    selectedFloorLabels() {
      if (!this.selectedIdc) return [];
      const labels = [];
      this.regionGroups.forEach((region) => {
        region.buildings.forEach((building) => {
          building.rows.forEach((row) => {
            (row.details || []).forEach((detail) => {
              if (this.selectedFloorKeys.includes(detail.key)) {
                labels.push(`${region.regionName} | ${building.buildingName} | ${row.floorName} | ${detail.detailName}`);
              }
            });
          });
        });
      });
      return labels;
    },
    startDateMin() {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      return this.formatDate(date);
    },
    checkAll: {
      get() {
        return this.rows.length > 0 && this.rows.every((row) => row.checked);
      },
      set(value) {
        this.rows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    scheduleCheckAll: {
      get() {
        return this.scheduleRows.length > 0 && this.scheduleRows.every((row) => row.checked);
      },
      set(value) {
        this.scheduleRows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    equipmentStatusCheckAll: {
      get() {
        return this.equipmentStatusRows.length > 0 && this.equipmentStatusRows.every((row) => row.checked);
      },
      set(value) {
        this.equipmentStatusRows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    workerCheckAll: {
      get() {
        return this.workerRows.length > 0 && this.workerRows.every((row) => row.checked);
      },
      set(value) {
        this.workerRows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    riskCheckAll: {
      get() {
        return this.riskRows.length > 0 && this.riskRows.every((row) => row.checked);
      },
      set(value) {
        this.riskRows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    cargoCheckAll: {
      get() {
        return this.cargoRows.length > 0 && this.cargoRows.every((row) => row.checked);
      },
      set(value) {
        this.cargoRows.forEach((row) => {
          row.checked = value;
        });
      }
    },
    hasSelected() {
      return this.rows.some((row) => row.checked);
    },
    hasScheduleSelected() {
      return this.scheduleRows.some((row) => row.checked);
    },
    hasValidScheduleRows() {
      return this.scheduleRows.some((row) => row.workItem || row.startDate || row.endDate);
    },
    activeHighRiskTabs() {
      const tabs = [];
      const order = ['고소작업', '화기작업', '밀폐공간', '화학물질', '전기작업', '중량물취급', '운전중작업'];
      order.forEach((t) => {
        if (this.highRiskTargets.includes(t)) tabs.push({ key: t, label: t });
      });
      this.heavyWorkTypes.forEach((t) => {
        tabs.push({ key: t, label: t });
      });
      return tabs;
    },
    scheduleDateDisabledFn() {
      const range = this.planDateRange;
      if (!range || !range[0] || !range[1]) return () => false;
      const planStart = new Date(range[0]);
      const planEnd = new Date(range[1]);
      planStart.setHours(0, 0, 0, 0);
      planEnd.setHours(0, 0, 0, 0);
      return (date) => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d < planStart || d > planEnd;
      };
    },
    timelineDayColStyle() {
      const n = this.scheduleTimelineDays.length;
      if (!n) return { width: '28px' };
      // 일자 컬럼 합계가 viewport 의 최소 40% 를 차지하도록 동적 계산.
      // 기본 최소 28px 보장. 작업기간이 짧으면 컬럼이 넓어지고, 길어지면 28px 까지 축소.
      return { width: `max(28px, ${(40 / n).toFixed(3)}vw)` };
    }
  },
  watch: {
    isHeavyWork(newVal) {
      if (!newVal) {
        this.heavyWorkTypes = [];
        this.resetHeavyEquipmentData();
      }
    },
    'excavationPermit.hasLifting'(newVal) {
      if (newVal) {
        if (!this.highRiskTargets.includes('중량물취급')) {
          this.highRiskTargets.push('중량물취급');
        }
        this.excavationPermit.hasHeavyCargo = true;
      }
    },
    'excavationPermit.hasHeavyCargo'(newVal) {
      if (newVal && !this.highRiskTargets.includes('중량물취급')) {
        this.highRiskTargets.push('중량물취급');
      }
    },
    'constrEquipPermit.hasHeavyCargo'(newVal) {
      if (newVal && !this.highRiskTargets.includes('중량물취급')) {
        this.highRiskTargets.push('중량물취급');
      }
    },
    heavyWorkTypes(newVal) {
      const heavyTriggers = ['지게차', '이동식크레인작업', '차량계하역운반기계'];
      if (newVal.some((t) => heavyTriggers.includes(t)) && !this.highRiskTargets.includes('중량물취급')) {
        this.highRiskTargets.push('중량물취급');
      }
      const highAltTriggers = ['차량형 고소작업대', '시저형 고소작업대'];
      if (newVal.some((t) => highAltTriggers.includes(t)) && !this.highRiskTargets.includes('고소작업')) {
        this.highRiskTargets.push('고소작업');
      }
      const syncTargets = ['차량형 고소작업대', '시저형 고소작업대'];
      syncTargets.forEach((name) => {
        const inHeavy = newVal.includes(name);
        const inAlt = this.highAltitudePermit.workTypes.includes(name);
        if (inHeavy && !inAlt) {
          this.highAltitudePermit.workTypes.push(name);
        } else if (!inHeavy && inAlt) {
          this.highAltitudePermit.workTypes = this.highAltitudePermit.workTypes.filter((t) => t !== name);
        }
      });
    },
    'highAltitudePermit.workTypes'(newVal) {
      const syncTargets = ['차량형 고소작업대', '시저형 고소작업대'];
      let addedHeavy = false;
      syncTargets.forEach((name) => {
        const inAlt = newVal.includes(name);
        const inHeavy = this.heavyWorkTypes.includes(name);
        if (inAlt && !inHeavy) {
          this.heavyWorkTypes.push(name);
          addedHeavy = true;
        } else if (!inAlt && inHeavy) {
          this.heavyWorkTypes = this.heavyWorkTypes.filter((t) => t !== name);
        }
      });
      if (addedHeavy) {
        this.isHeavyWork = true;
        if (!this.highRiskTargets.includes('고소작업')) {
          this.highRiskTargets.push('고소작업');
        }
      }
    },
    activeHighRiskTabs(newTabs) {
      if (newTabs.length === 0) {
        this.activeHighRiskTab = null;
      } else if (!newTabs.find((t) => t.key === this.activeHighRiskTab)) {
        this.activeHighRiskTab = newTabs[0].key;
      }
    },
    selectedIdcCode(newVal) {
      this.selectedFloorKeys = [];
      this.scheduleRows.forEach((row) => {
        row.regionCode = newVal || '';
        row.buildingCode = '';
        row.floorCode = '';
        row.detailCode = '';
      });
      // IDC 변경 시 planId 도 새 site prefix 로 재발급
      this.issuePlanId();
    }
  },
  created() {},
  mounted() {
    // 약관 동의 화면에서 입력한 회사명 프리필
    const consent = this.readConsent();
    if (consent && consent.companyName && !this.companyName) {
      this.companyName = consent.companyName;
    }
    // 위치 목록을 먼저 로드해 selectedIdcCode 가 세팅된 뒤 planId 발급
    this.loadLocationOptions().then(() => this.issuePlanId());
  },
  // 이 화면은 WorkPermitMain 의 <keep-alive> 로 캐시되어 재진입 시 mounted 가 다시 실행되지 않는다.
  // 약관동의(서약 회사명)로 되돌아가 회사명을 바꾼 뒤 다시 오면 최신 값을 반영해야 하므로 activated 에서 동기화.
  activated() {
    const consent = this.readConsent();
    if (consent && consent.companyName) {
      this.companyName = consent.companyName;
    }
    // 작성 중 신청 토큰(3시간) 만료 방지 — 30분마다 슬라이딩 갱신
    this.startTokenRefresh();
  },
  deactivated() {
    this.stopTokenRefresh();
  },
  beforeDestroy() {
    this.stopTokenRefresh();
  },
  methods: {
    // ── 신청 토큰 슬라이딩 갱신 (작성 도중 만료 방지) ──
    startTokenRefresh() {
      this.stopTokenRefresh();
      this._tokenRefreshTimer = setInterval(() => {
        const token = window.store.getters['auth/data'];
        if (token) refreshFlowToken();
      }, 30 * 60 * 1000);
    },
    stopTokenRefresh() {
      if (this._tokenRefreshTimer) {
        clearInterval(this._tokenRefreshTimer);
        this._tokenRefreshTimer = null;
      }
    },
    // ── 이전 허가서 불러오기 ──────────────────────────────
    openLoadModal() {
      this.showLoadModal = true;
    },
    closeLoadModal() {
      this.showLoadModal = false;
    },
    formatPermitPeriod(r) {
      const fmt = (ms) => {
        if (!ms) return '';
        const d = new Date(Number(ms));
        if (isNaN(d.getTime())) return '';
        const p = (n) => (n < 10 ? '0' + n : '' + n);
        return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
      };
      const s = fmt(r.fromDate);
      const e = fmt(r.toDate);
      if (!s && !e) return '-';
      return s + ' ~ ' + e;
    },
    async searchReusablePermits() {
      if (!this.canSearchLoad || this.loadSearching) return;
      this.loadSearching = true;
      this.loadSearched = false;
      try {
        const res = await this.$http.get('/api/public/work-permit/reusable', {
          params: {
            ordererName: this.loadForm.ordererName.trim(),
            ordererEmail: this.loadForm.ordererEmail.trim(),
            managerName: this.loadForm.managerName.trim(),
            planId: this.loadForm.planId.trim()
          }
        });
        const data = res && res.data ? (res.data.payload != null ? res.data.payload : res.data) : [];
        this.loadResults = Array.isArray(data) ? data : [];
      } catch (e) {
        console.log('이전 허가서 검색 실패', e);
        this.loadResults = [];
      } finally {
        this.loadSearching = false;
        this.loadSearched = true;
      }
    },
    applyLoadedPermit(permit, continueMode) {
      let p = {};
      try { p = permit && permit.payload ? JSON.parse(permit.payload) : {}; } catch (e) { p = {}; }

      // 메타데이터 (엔티티 top-level 우선, payload fallback). planId/작업일정은 새로 발급/입력.
      this.planName = permit.planName || p.planName || '';
      this.companyName = permit.companyName || p.companyName || '';
      this.workManager = permit.workManager || p.workManager || '';
      this.workManagerPhone = permit.workManagerPhone || p.workManagerPhone || '';
      this.workPeopleCount = (p.workPeopleCount != null ? p.workPeopleCount
        : (permit.workPeopleCount != null ? permit.workPeopleCount : null));
      this.safetyManager = permit.safetyManager || p.safetyManager || '';
      this.safetyManagerPhone = permit.safetyManagerPhone || p.safetyManagerPhone || '';

      const permitKeys = [
        'excavationPermit', 'cargoEquipPermit', 'mobileCranePermit', 'constrEquipPermit',
        'forkliftPermit', 'boomLiftPermit', 'scissorLiftPermit', 'fireWorkPermit',
        'highAltitudePermit', 'confinedSpacePermit', 'electricWorkPermit', 'chemicalPermit',
        'operatingWorkPermit', 'heavyLiftPermit'
      ];
      const fillRest = () => {
        this.locationDetail = p.locationDetail || '';
        if (Array.isArray(p.selectedFloorKeys)) this.selectedFloorKeys = p.selectedFloorKeys.slice();
        if (Array.isArray(p.scheduleRows) && p.scheduleRows.length) this.scheduleRows = p.scheduleRows;
        if (Array.isArray(p.rows) && p.rows.length) this.rows = p.rows;
        if (Array.isArray(p.highRiskTargets)) this.highRiskTargets = p.highRiskTargets.slice();
        if (Array.isArray(p.heavyWorkTypes)) this.heavyWorkTypes = p.heavyWorkTypes.slice();
        // isHeavyWork: payload 값 우선, 중량작업 유형이 있으면 강제 true
        this.isHeavyWork = !!p.isHeavyWork || (Array.isArray(p.heavyWorkTypes) && p.heavyWorkTypes.length > 0);
        if (Array.isArray(p.cargoRows) && p.cargoRows.length) this.cargoRows = p.cargoRows;
        permitKeys.forEach((k) => { if (p[k] && typeof p[k] === 'object') this[k] = p[k]; });
      };

      // 이어작성 모드: 원본 문서번호·작업일정 유지 → 재저장 시 같은 DRAFT 갱신.
      // (selectedIdcCode watcher 가 planId 를 재발급하므로, idc 반영 이후에 원본값으로 되돌린다)
      const finishContinue = () => {
        if (continueMode) {
          if (permit.planId) this.planId = permit.planId;
          if (Array.isArray(p.planDateRange)) this.planDateRange = p.planDateRange.slice();
        }
      };

      // idcCode 가 다르면 site 를 맞추고(watcher 가 위치/문서번호 재설정), 그 뒤 위치 의존 필드 채움
      const targetIdc = p.idcCode || permit.idcCode || null;
      if (targetIdc && targetIdc !== this.selectedIdcCode) {
        this.selectedIdcCode = targetIdc;
        this.$nextTick(() => { fillRest(); finishContinue(); });
      } else {
        fillRest();
        finishContinue();
      }

      this.showLoadModal = false;
      alert(continueMode
        ? '임시저장한 내용을 불러왔습니다. 이어서 작성 후 저장하면 같은 문서번호로 갱신됩니다.'
        : '이전 허가서 내용을 불러왔습니다. 작업 계획 번호와 작업 일정은 새로 입력해주세요.');
    },
    loadLiftingFromHeavyLift(targetKey) {
      const src = this.heavyLiftPermit.liftingList;
      if (!src || src.length === 0) return;
      this[targetKey].liftingList = src.map((item) => ({ ...item, id: Date.now() + Math.random() }));
    },
    loadCargoFromHeavyLift(targetKey) {
      const src = this.heavyLiftPermit.cargoList;
      if (!src || src.length === 0) return;
      this[targetKey].cargoList = src.map((item) => ({ ...item, id: Date.now() + Math.random() }));
    },
    // 지게차 (하역운반) 화물상태 — 중량물작업계획서 첫 중량물에서 겹치는 항목만 가져오기.
    // (지게차는 화물이 단일 객체, 적재상태는 지게차 고유라 화물의 공통 필드만 복사)
    loadForkliftCargoFromHeavyLift() {
      const src = this.heavyLiftPermit.cargoList;
      if (!src || src.length === 0) {
        this.noti('알림', '중량물작업계획서에 중량물 정보가 없습니다.', 'warning');
        return;
      }
      const s = src[0];
      const c = this.forkliftPermit.cargoAndLoad.cargo;
      c.name = s.name || '';
      c.unitWeight = s.unitWeight || '';
      c.type = s.type || '';
      c.shape = s.shape || '';
      c.totalQty = s.totalQty || '';
      c.totalWeight = s.totalWeight || '';
      c.qtyPerTrip = s.qtyPerLift || '';       // 1회 양중수량 → 1회 운반수량
      c.weightPerTrip = s.weightPerLift || ''; // 1회 양중중량 → 1회 운반중량
      this.noti('가져오기 완료', '중량물작업계획서의 화물 정보를 불러왔습니다. (겹치는 항목만)', 'success');
    },
    loadOperatorsFromHeavyLift(targetKey) {
      const src = this.heavyLiftPermit.operators;
      if (!src || src.length === 0) return;
      // 운전원은 대상 허가서와 구조 동일 → 그대로 복사
      this[targetKey].operators = src.map((o) => ({ name: o.name, license: o.license, phone: o.phone }));
    },
    loadGuidesFromHeavyLift(targetKey) {
      const src = this.heavyLiftPermit.guides;
      if (!src || src.length === 0) return;
      // 유도자도 구조 동일 → signalMethods 배열은 새 배열로 복사
      this[targetKey].guides = src.map((g) => ({ name: g.name, signalMethods: [...(g.signalMethods || [])], phone: g.phone }));
    },
    loadEquipmentFromHeavyLift(targetKey) {
      const src = this.heavyLiftPermit.equipmentList;
      if (!src || src.length === 0) return;
      // 기계·장비 제원은 허가서마다 항목이 달라, 대상 양식(스키마)은 유지하고 매칭되는 항목만 값 복사.
      // 대상의 첫 항목을 스키마 템플릿으로 사용(항상 최소 1건 존재).
      const tgtList = this[targetKey].equipmentList;
      const template = (tgtList && tgtList.length) ? tgtList[0] : null;
      this[targetKey].equipmentList = src.map((s) => {
        if (!template) return { ...s, id: Date.now() + Math.random() };
        const item = {};
        Object.keys(template).forEach((k) => {
          if (k === 'id') { item[k] = Date.now() + Math.random(); return; }
          if (Object.prototype.hasOwnProperty.call(s, k)) {
            // 매칭되는 항목만 중량물 값으로 채움
            item[k] = Array.isArray(s[k]) ? s[k].slice() : s[k];
          } else {
            // 매칭 안 되는 항목은 대상 양식 유지(타입별 빈 값)
            const d = template[k];
            if (Array.isArray(d)) item[k] = [];
            else if (typeof d === 'boolean') item[k] = d;
            else if (d === null) item[k] = null;
            else item[k] = '';
          }
        });
        return item;
      });
    },
    formatPhone(value) {
      const digits = value.replace(/\D/g, '');
      if (digits.length <= 3) return digits;
      if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
    },
    isValidPhone(value) {
      return /^0\d{1,2}-\d{3,4}-\d{4}$/.test(value);
    },
    async issuePlanId() {
      // BE 에서 마지막 시퀀스 기반으로 발급. {site}-yyyyMMdd-{4자리}
      // 동시 발급으로 중복 발생할 경우 제출 시점에 BE 가 자동 재발급해 응답에 담아 줌.
      try {
        const params = this.selectedIdcCode ? { idcCode: this.selectedIdcCode } : {};
        const res = await this.$http.get('/api/public/work-permit/next-plan-id', { params });
        const data = res && res.data ? (res.data.payload || res.data) : null;
        if (data && data.planId) {
          this.planId = data.planId;
        }
      } catch (e) {
        console.log('next-plan-id 발급 실패', e);
      }
    },
    async loadLocationOptions() {
      try {
        const result = await this.$http.get('/api/public/safety-location/idcList');
        const list = (result.data || []).filter((item) => item.isDeleteYN === 'N');
        this.idcList = list.map((item) => Object.assign({}, item));
        this.selectedIdcCode = this.idcList[0] ? this.idcList[0].locationCode : null;
      } catch (e) {
        console.log(e);
      }
    },
    onPlanDatePick(date) {
      this.pendingRangeStart = date;
    },
    isPlanDateDisabled(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      if (d <= today) return true;
      const ref = this.pendingRangeStart || (this.planDateRange && this.planDateRange[0]) || null;
      if (!ref) return false;
      const maxEnd = moment(ref).add(1, 'year').toDate();
      return date > maxEnd;
    },
    handlePlanDateChange(value) {
      this.pendingRangeStart = null;
      if (!value || value.length < 2) return;
      const start = moment(value[0]);
      let end = moment(value[1]);
      if (end.isBefore(start)) {
        end = start.clone();
      }
      const maxEnd = start.clone().add(1, 'year');
      if (end.isAfter(maxEnd)) {
        end = maxEnd;
      }
      this.planDateRange = [start.toDate(), end.toDate()];
    },
    getSelectLabel(value) {
      if (!value) return '';
      if (Array.isArray(value)) {
        if (value.length === 0) return '';
        return value
          .map((v) => (typeof v === 'string' ? v : this.formatOptionLabel(v)))
          .filter(Boolean)
          .join(', ');
      }
      if (typeof value === 'string') return value;
      if (value.name) return this.formatOptionLabel(value);
      return '';
    },
    formatOptionLabel(option) {
      if (!option) return '';
      if (option.category && option.name) return `${option.category} / ${option.name}`;
      if (option.name) return option.name;
      return '';
    },
    openSelectModal(row, setIndex, field) {
      const config = this.getSelectConfig(field);
      const selectedValue = this.toArray(row.sets[setIndex][field]);
      const disabledOptions = field === 'hazard' ? this.getDisabledHazards(row, setIndex) : [];
      this.openModal({
        view: 'modal/WorkPermitSelect',
        side: false,
        title: config.title,
        showBottom: false,
        props: {
          options: config.options,
          selected: selectedValue,
          multiple: true,
          disabledOptions: disabledOptions,
          useCheckbox: true,
          nameLabel: config.nameLabel,
          descriptionLabel: '내용 설명',
          columns: config.columns,
          valueKey: config.valueKey,
          emptyText: '목록이 없습니다.',
          onSelect: (option) => {
            if (field === 'hazard') {
              this.applyHazardSelection(row, setIndex, option);
              return;
            }
            this.$set(row.sets[setIndex], field, Array.isArray(option) ? option : this.toArray(option));
          }
        }
      });
    },
    getSelectConfig(field) {
      if (field === 'hazard') {
        return {
          title: '위험종류 선택',
          nameLabel: '위험종류',
          options: this.hazardOptions,
          valueKey: 'key',
          columns: [
            { label: '위험종류', key: 'name', width: '180px' },
            { label: '내용 설명', key: 'description', width: '50%' },
            { label: '예시', key: 'ex', width: '50%' }
          ]
        };
      }
      if (field === 'protection') {
        return {
          title: '보호구 선택',
          nameLabel: '보호구',
          options: this.protectionOptions,
          valueKey: 'key',
          columns: [
            { label: '구분', key: 'category', width: '180px' },
            { label: '보호구명', key: 'name' }
          ]
        };
      }
      return {
        title: '작업도구 선택',
        nameLabel: '작업도구',
        options: this.toolOptions,
        valueKey: 'key',
        columns: [
          { label: '작업도구', key: 'name', width: '240px' },
          { label: '설명', key: 'description' }
        ]
      };
    },
    getEndDateMin(row) {
      if (row && row.startDate && row.startDate > this.startDateMin) {
        return row.startDate;
      }
      return this.startDateMin;
    },
    handleStartDateChange(row) {
      const minDate = this.getEndDateMin(row);
      if (row.endDate && row.endDate < minDate) {
        row.endDate = '';
      }
    },
    getScheduleDateRange(row) {
      const start = row.startDate ? new Date(row.startDate) : null;
      const end = row.endDate ? new Date(row.endDate) : null;
      return [start, end];
    },
    handleScheduleRangeChange(row, value) {
      if (value && value[0]) {
        row.startDate = this.formatDate(value[0]);
      } else {
        row.startDate = '';
      }
      if (value && value[1]) {
        row.endDate = this.formatDate(value[1]);
      } else {
        row.endDate = '';
      }
    },
    /**
     * 공정표 행의 선택된 상세위치가 '기타' 인지 여부.
     * 작업위치 선택(allowedScheduleLocations)으로 필터된 getScheduleDetails 가 아니라
     * 전체 위치 트리(scheduleRowLocationNames) 기준으로 판별 → 업로드된(미선택) 위치도 정상 판별.
     */
    isScheduleDetailEtc(row) {
      if (!row || !row.detailCode) return false;
      return this.scheduleRowLocationNames(row).detail === '기타';
    },
    /** 상세위치 변경 시 '기타' 가 아니면 기타 입력값 초기화. */
    onScheduleDetailChange(row) {
      if (!this.isScheduleDetailEtc(row)) row.detailLocation = '';
    },
    /** 공정표 행의 위치 코드(region/building/floor/detail)를 위치 트리에서 이름으로 변환. */
    scheduleRowLocationNames(row) {
      const regions = this.scheduleRegions || [];
      const region = regions.find((r) => r.locationCode === row.regionCode);
      const building = region && (region.children || []).find((b) => b.locationCode === row.buildingCode);
      const floor = building && (building.children || []).find((f) => f.locationCode === row.floorCode);
      const detail = floor && (floor.children || []).find((d) => d.locationCode === row.detailCode);
      return {
        region: region ? region.locationName : '',
        building: building ? building.locationName : '',
        floor: floor ? floor.locationName : '',
        detail: detail ? detail.locationName : ''
      };
    },
    /** 'YYYY-MM-DD'(또는 유사) → 템플릿 E/F 열용 YYYYMMDD 정수. 비면 ''. */
    toTemplateDate(d) {
      if (!d) return '';
      const digits = String(d).replace(/[^0-9]/g, '');
      return digits.length >= 8 ? Number(digits.slice(0, 8)) : '';
    },
    normalizeNumber(value) {
      if (value == null || value === '') return null;
      const num = Number(value);
      return Number.isFinite(num) ? num : null;
    },
    normalizeDateValue(value) {
      if (!value) return '';
      if (value instanceof Date) {
        return this.formatDate(value);
      }
      if (typeof value === 'number') {
        // YYYYMMDD 정수(예: 20260528) 우선 처리
        if (Number.isInteger(value) && value >= 19000101 && value <= 99991231) {
          const str = String(value);
          if (/^\d{8}$/.test(str)) {
            return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
          }
        }
        // 엑셀 날짜 일련번호(예: 44197 = 2021-01-01)
        const parsed = XLSX.SSF.parse_date_code(value);
        if (parsed && parsed.y && parsed.m && parsed.d) {
          return this.formatDate(new Date(parsed.y, parsed.m - 1, parsed.d));
        }
      }
      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return '';
        const normalized = trimmed.replace(/\./g, '-').replace(/\//g, '-');
        if (/^\d{8}$/.test(normalized)) {
          return `${normalized.slice(0, 4)}-${normalized.slice(4, 6)}-${normalized.slice(6, 8)}`;
        }
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
          const parts = normalized.split('-');
          return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
        }
      }
      return '';
    },
    matchOption(options, value) {
      if (!value) return '';
      const text = String(value).trim();
      if (!text) return '';
      const normalized = text.replace(/\s+/g, '');
      const matched = options.find((option) => {
        if (!option) return false;
        if (option.key && option.key === text) return true;
        if (option.name && option.name === text) return true;
        if (option.category && option.name) {
          const combined = `${option.category} / ${option.name}`.replace(/\s+/g, '');
          if (combined === normalized) return true;
        }
        return false;
      });
      return matched || text;
    },
    splitMultiValue(value) {
      if (!value) return [];
      const text = String(value).trim();
      if (!text) return [];
      const separator = text.includes(';') ? ';' : (text.includes(',') ? ',' : null);
      if (!separator) return [text];
      return text.split(separator).map((item) => item.trim()).filter((item) => item);
    },
    parseDate(value) {
      if (!value) return null;
      const parts = value.split('-');
      if (parts.length !== 3) return null;
      const year = Number(parts[0]);
      const month = Number(parts[1]);
      const day = Number(parts[2]);
      if (!year || !month || !day) return null;
      const date = new Date(year, month - 1, day);
      if (Number.isNaN(date.getTime())) return null;
      date.setHours(0, 0, 0, 0);
      return date;
    },
    toStartOfDay(date) {
      const next = new Date(date);
      next.setHours(0, 0, 0, 0);
      return next;
    },
    diffDays(start, end) {
      const ms = 24 * 60 * 60 * 1000;
      return Math.round((end - start) / ms);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    createScheduleRow() {
      return {
        id: this.createRowId(),
        checked: false,
        regionCode: this.selectedIdcCode || '',
        buildingCode: '',
        floorCode: '',
        detailCode: '',
        detailLocation: '',
        workItem: '',
        startDate: '',
        endDate: ''
      };
    },
    createRow() {
      return {
        id: this.createRowId(),
        checked: false,
        startDate: '',
        endDate: '',
        item: '',
        sets: [this.createSet()]
      };
    },
    createSet() {
      return {
        procedure: '',
        riskFactor: '',
        hazard: '',
        protection: '',
        tool: '',
        currentSafety: '',
        // 위험도 기본값 '하'. 미선택 상태로 넘어가던 것을 막되, 드롭다운에서 상/중으로 변경 가능.
        // (상/중이면 findMissingAdditionalSafety 가 추가 안전보건조치를 필수로 요구한다)
        riskLevel: '하',
        additionalSafety: ''
      };
    },
    getRiskLevelKey(level) {
      if (level === '상') return 'high';
      if (level === '중') return 'mid';
      if (level === '하') return 'low';
      return '';
    },
    createEquipmentStatusRow() {
      return {
        id: this.createRowId(),
        checked: false,
        name: '',
        load: '',
        count: null,
        inspectDate: ''
      };
    },
    createWorkerRow() {
      return {
        id: this.createRowId(),
        checked: false,
        name: '',
        title: '',
        role: '',
        note: ''
      };
    },
    createRiskRow() {
      return {
        id: this.createRowId(),
        checked: false,
        task: '',
        equipment: '',
        risk: '',
        measure: ''
      };
    },
    createCargoRow() {
      return {
        id: this.createRowId(),
        checked: false,
        item: '',
        size: '',
        weight: ''
      };
    },
    createRowId() {
      return 'row-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    },
    isEmptyWorkRow(row) {
      if (!row) return true;
      const hasCore = row.startDate || row.endDate || row.item || row.procedure || row.workType;
      const hasScore = row.accidentFrequency || row.exposureFrequency || row.intensity;
      const hasSet = (row.sets || []).some((set) => set.hazard || set.protection || set.tool || set.safetyPlan);
      return !hasCore && !hasScore && !hasSet;
    },
    downloadWorkItemsTemplate() {
      const headers = [
        '작업시작일',
        '작업종료일',
        '항목',
        '작업절차',
        '작업종류',
        '위험종류',
        '보호구',
        '작업도구',
        '안전대책',
        '사고빈도',
        '노출빈도',
        '강도'
      ];
      const sheet = XLSX.utils.aoa_to_sheet([headers]);
      const book = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(book, sheet, '작업항목');
      const output = XLSX.write(book, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([output], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '작업항목_템플릿.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    triggerWorkItemsUpload() {
      if (this.$refs.workItemsExcelInput) {
        this.$refs.workItemsExcelInput.click();
      }
    },
    handleWorkItemsUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'array', cellDates: true });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
        if (!rows || rows.length === 0) return;

        const headerRow = rows[0] || [];
        const normalize = (value) => String(value || '').replace(/\s+/g, '');
        const findIndex = (label, fallback) => {
          const target = normalize(label);
          const index = headerRow.findIndex((cell) => normalize(cell) === target);
          return index > -1 ? index : fallback;
        };
        const colIndex = {
          startDate: findIndex('작업시작일', 0),
          endDate: findIndex('작업종료일', 1),
          item: findIndex('항목', 2),
          procedure: findIndex('작업절차', 3),
          workType: findIndex('작업종류', 4),
          hazard: findIndex('위험종류', 5),
          protection: findIndex('보호구', 6),
          tool: findIndex('작업도구', 7),
          safetyPlan: findIndex('안전대책', 8),
          accident: findIndex('사고빈도', 9),
          exposure: findIndex('노출빈도', 10),
          intensity: findIndex('강도', 11)
        };

        const imported = [];
        rows.slice(1).forEach((row) => {
          const item = row[colIndex.item] || '';
          const startDate = this.normalizeDateValue(row[colIndex.startDate]);
          const endDate = this.normalizeDateValue(row[colIndex.endDate]);
          const procedure = row[colIndex.procedure] || '';
          const workType = row[colIndex.workType] || '';
          const hazardValue = row[colIndex.hazard] || '';
          const protectionValue = row[colIndex.protection] || '';
          const toolValue = row[colIndex.tool] || '';
          const safetyPlan = row[colIndex.safetyPlan] || '';
          const accident = this.normalizeNumber(row[colIndex.accident]);
          const exposure = this.normalizeNumber(row[colIndex.exposure]);
          const intensity = this.normalizeNumber(row[colIndex.intensity]);

          const isEmpty = !item && !startDate && !endDate && !procedure && !workType && !hazardValue && !protectionValue && !toolValue && !safetyPlan && accident == null && exposure == null && intensity == null;
          if (isEmpty) return;

          const newRow = this.createRow();
          newRow.startDate = startDate;
          newRow.endDate = endDate;
          newRow.item = item;
          newRow.procedure = procedure;
          newRow.workType = workType;
          newRow.accidentFrequency = accident;
          newRow.exposureFrequency = exposure;
          newRow.intensity = intensity;

          const hazards = this.splitMultiValue(hazardValue);
          // 보호구·작업도구는 UI 와 동일하게 복수 선택(배열)로 반영 — 셀에 여러 값이 있으면 한 세트에 모두 담는다.
          const protectionArr = this.splitMultiValue(protectionValue)
            .map((v) => this.matchOption(this.protectionOptions, v)).filter(Boolean);
          const toolArr = this.splitMultiValue(toolValue)
            .map((v) => this.matchOption(this.toolOptions, v)).filter(Boolean);
          // 세트 수는 재해유형(위험종류) 개수 기준(복수 재해유형 → 복수 세트). 보호구/작업도구는 각 세트에 공통 적용.
          const setCount = Math.max(hazards.length, 1);
          newRow.sets = [];
          for (let i = 0; i < setCount; i += 1) {
            const hazard = this.matchOption(this.hazardOptions, hazards[i] || hazards[0] || '');
            newRow.sets.push({
              ...this.createSet(),
              hazard,
              protection: protectionArr.slice(),
              tool: toolArr.slice(),
              safetyPlan: safetyPlan || ''
            });
          }
          this.handleStartDateChange(newRow);

          imported.push(newRow);
        });

        if (imported.length > 0) {
          const shouldReplace = this.rows.length === 1 && this.isEmptyWorkRow(this.rows[0]);
          this.rows = shouldReplace ? imported : this.rows.concat(imported);
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = '';
    },
    addScheduleRow() {
      this.scheduleRows.push(this.createScheduleRow());
    },
    /**
     * 위 "작업 위치"에서 선택한 위치(selectedFloorKeys: idc|building|floor|detail)를
     * 예정 공정표 행으로 자동 추가. 이미 공정표에 있는 위치는 건너뜀.
     * 공정표가 빈 행 1개뿐이면 교체, 아니면 뒤에 추가.
     */
    loadSelectedLocationsToSchedule() {
      const keys = this.selectedFloorKeys || [];
      if (!keys.length) {
        this.noti('위치 없음', '먼저 위 "작업 위치"에서 위치를 선택해 주세요.', 'warning');
        return;
      }
      const comboOf = (r) => [r.regionCode || '', r.buildingCode || '', r.floorCode || '', r.detailCode || ''].join('|');
      const existing = new Set(this.scheduleRows.map(comboOf));
      const toAdd = [];
      keys.forEach((k) => {
        const parts = String(k).split('|'); // idc|building|floor|detail
        const row = this.createScheduleRow();
        row.regionCode = parts[0] || this.selectedIdcCode || '';
        row.buildingCode = parts[1] || '';
        row.floorCode = parts[2] || '';
        row.detailCode = parts[3] || '';
        const combo = comboOf(row);
        if (existing.has(combo)) return; // 이미 공정표에 있는 위치
        existing.add(combo);
        toAdd.push(row);
      });
      if (!toAdd.length) {
        this.noti('추가할 위치 없음', '선택한 위치가 이미 공정표에 있습니다.', 'info');
        return;
      }
      const onlyEmpty = this.scheduleRows.length === 1 && this.isEmptyScheduleRow(this.scheduleRows[0]);
      this.scheduleRows = onlyEmpty ? toAdd : this.scheduleRows.concat(toAdd);
      this.noti('위치 반영', `${toAdd.length}개 위치를 예정 공정표에 추가했습니다. 작업항목·일정을 입력하세요.`, 'success');
    },
    removeScheduleRows() {
      this.scheduleRows = this.removeChecked(this.scheduleRows, this.createScheduleRow);
    },
    async downloadScheduleTemplate() {
      const ExcelJS = (await import('exceljs')).default;
      const workbook = new ExcelJS.Workbook();
      const mainSheet = workbook.addWorksheet('작업계획');
      const refSheet = workbook.addWorksheet('참조');

      // 위치 데이터 수집
      const regions = this.scheduleRegions;
      const regionNames = regions.map((r) => r.locationName);
      const regionBuildings = regions.map((region) =>
        (region.children || []).filter((b) => b.isDeleteYN == "N").map((b) => b.locationName)
      );
      // 관 → 층, 층 → 상세 종속관계 수집 (관/층 이름이 중복될 경우 floor 목록 병합)
      const buildingFloors = {};
      const floorDetails = {};   // key: `${관}|${층}` (층 이름이 건물마다 겹쳐도 상세가 섞이지 않도록 복합키)
      const uniqueBuildings = [];
      const floorKeys = [];      // 참조-상세 컬럼 순서 = 복합키 목록
      regions.forEach((region) => {
        (region.children || []).filter((b) => b.isDeleteYN == "N").forEach((building) => {
          if (!uniqueBuildings.includes(building.locationName)) {
            uniqueBuildings.push(building.locationName);
            buildingFloors[building.locationName] = [];
          }
          (building.children || []).filter((f) => f.isDeleteYN == "N").forEach((floor) => {
            if (!buildingFloors[building.locationName].includes(floor.locationName)) {
              buildingFloors[building.locationName].push(floor.locationName);
            }
            const fKey = building.locationName + '|' + floor.locationName;
            if (!floorDetails[fKey]) {
              floorDetails[fKey] = [];
              floorKeys.push(fKey);
            }
            (floor.children || []).filter((d) => d.isDeleteYN == "N").forEach((detail) => {
              if (!floorDetails[fKey].includes(detail.locationName)) {
                floorDetails[fKey].push(detail.locationName);
              }
            });
          });
        });
      });

      const hazardNames = this.hazardOptions.map((o) => o.name);
      const protectionNames = this.protectionOptions.map((o) => o.name);
      const toolNames = this.toolOptions.map((o) => o.name);

      // 참조 시트: 구분→관 + 위험요인/보호구/작업도구
      const toColLetter = (n) => {
        let s = '';
        let x = n;
        while (x >= 0) {
          s = String.fromCharCode(65 + (x % 26)) + s;
          x = Math.floor(x / 26) - 1;
        }
        return s;
      };
      const hazardColIdx = 1 + regions.length;
      const protectionColIdx = hazardColIdx + 1;
      const toolColIdx = protectionColIdx + 1;
      const hazardColLetter = toColLetter(hazardColIdx);
      const protectionColLetter = toColLetter(protectionColIdx);
      const toolColLetter = toColLetter(toolColIdx);
      const refMaxRows = Math.max(
        regionNames.length,
        ...regionBuildings.map((b) => b.length),
        hazardNames.length,
        protectionNames.length,
        toolNames.length,
        0
      );

      refSheet.addRow(['구분목록', ...regionNames, '재해유형', '보호구', '작업도구']);
      for (let i = 0; i < refMaxRows; i++) {
        refSheet.addRow([
          regionNames[i] || '',
          ...regionBuildings.map((b) => b[i] || ''),
          hazardNames[i] || '',
          protectionNames[i] || '',
          toolNames[i] || '',
        ]);
      }

      // 참조-층 시트: 관 → 층 (row1=관 이름들, row2+=각 관의 층)
      const floorSheet = workbook.addWorksheet('참조-층');
      floorSheet.addRow(uniqueBuildings);
      const floorMaxRows = Math.max(0, ...uniqueBuildings.map((b) => buildingFloors[b].length));
      for (let i = 0; i < floorMaxRows; i++) {
        floorSheet.addRow(uniqueBuildings.map((b) => buildingFloors[b][i] || ''));
      }

      // 참조-상세 시트: (관|층) → 상세 (row1=복합키들, row2+=각 층의 상세)
      const detailSheet = workbook.addWorksheet('참조-상세');
      detailSheet.addRow(floorKeys);
      const detailMaxRows = Math.max(0, ...floorKeys.map((f) => floorDetails[f].length));
      for (let i = 0; i < detailMaxRows; i++) {
        detailSheet.addRow(floorKeys.map((f) => floorDetails[f][i] || ''));
      }

      // 메인 시트 헤더
      const headers = [
        '구분', '관', '층', '상세위치',
        '작업 시작일(예:20260101)', '작업 종료일(예:20260101)',
        '작업항목', '작업절차(세부작업순서)',
        '위험요인', '재해유형', '보호구', '작업도구',
        '현재 안전보건 조치', '위험도(상/중/하)', '추가 안전보건 조치'
      ];
      const headerRow = mainSheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      headerRow.height = 28;
      const colWidths = [12, 16, 10, 18, 22, 22, 18, 30, 20, 18, 18, 18, 24, 14, 24];
      colWidths.forEach((w, i) => { mainSheet.getColumn(i + 1).width = w; });

      // 예정 공정표 입력에 이미 입력된 행이 있으면 템플릿에 채워서 다운로드 (구분/관/층/상세위치/시작일/종료일/작업항목)
      (this.scheduleRows || []).filter((r) => !this.isEmptyScheduleRow(r)).forEach((r) => {
        const n = this.scheduleRowLocationNames(r);
        // 상세위치가 '기타'면 입력한 기타 내용을 상세위치 칸에 표기
        const detailCell = (n.detail === '기타' && String(r.detailLocation || '').trim())
          ? String(r.detailLocation).trim()
          : n.detail;
        mainSheet.addRow([
          n.region, n.building, n.floor, detailCell,
          this.toTemplateDate(r.startDate), this.toTemplateDate(r.endDate),
          r.workItem || ''
          // H~O(작업절차/위험성평가)은 공란 — 예정 공정표만 반영
        ]);
      });

      const ROW_LIMIT = 1001;
      // 구분(A)
      if (regionNames.length > 0) {
        mainSheet.dataValidations.add(`A2:A${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: [`'참조'!$A$2:$A$${regionNames.length + 1}`],
          showErrorMessage: true,
          errorTitle: '유효하지 않은 값',
          error: '목록에서 선택하세요.',
        });
      }
      // 관(B) - 구분에 따른 종속
      mainSheet.dataValidations.add(`B2:B${ROW_LIMIT}`, {
        type: 'list',
        allowBlank: true,
        formulae: ["OFFSET('참조'!$A$1,1,MATCH(A2,'참조'!$1:$1,0)-1,COUNTA(OFFSET('참조'!$A$1,1,MATCH(A2,'참조'!$1:$1,0)-1,100,1)),1)"],
        showErrorMessage: true,
        errorTitle: '유효하지 않은 값',
        error: '구분을 먼저 선택한 후 선택하세요.',
      });
      // 층(C) - 관에 따른 종속
      if (uniqueBuildings.length > 0) {
        mainSheet.dataValidations.add(`C2:C${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: ["OFFSET('참조-층'!$A$1,1,MATCH(B2,'참조-층'!$1:$1,0)-1,COUNTA(OFFSET('참조-층'!$A$1,1,MATCH(B2,'참조-층'!$1:$1,0)-1,100,1)),1)"],
          showErrorMessage: true,
          errorTitle: '유효하지 않은 값',
          error: '관을 먼저 선택한 후 선택하세요.',
        });
      }
      // 상세위치(D) - (관|층) 복합키에 따른 종속. 층 이름이 건물마다 겹쳐도 해당 건물·층의 상세만 노출.
      if (floorKeys.length > 0) {
        mainSheet.dataValidations.add(`D2:D${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: ["OFFSET('참조-상세'!$A$1,1,MATCH(B2&\"|\"&C2,'참조-상세'!$1:$1,0)-1,COUNTA(OFFSET('참조-상세'!$A$1,1,MATCH(B2&\"|\"&C2,'참조-상세'!$1:$1,0)-1,100,1)),1)"],
          showErrorMessage: false, // '기타' 등 목록 밖 자유입력 허용 (드롭박스는 참고용)
        });
      }
      // 날짜 열(E, F) — YYYYMMDD 8자리 정수. 유효성(whole)과 셀 서식(정수)을 일치시켜야 함.
      // (텍스트 서식 '@' 이면 입력값이 문자열이 되어 whole 검증에 걸려 정상 입력도 거부됨)
      for (const col of ['E', 'F']) {
        mainSheet.dataValidations.add(`${col}2:${col}${ROW_LIMIT}`, {
          type: 'whole',
          operator: 'between',
          allowBlank: true,
          formulae: [19000101, 20991231],
          showErrorMessage: true,
          errorTitle: '날짜 형식 오류',
          error: '날짜를 YYYYMMDD 형식의 8자리 숫자로 입력하세요. (예: 20260101)',
        });
        mainSheet.getColumn(col).numFmt = '0';
      }
      // 재해유형(J)
      if (hazardNames.length > 0) {
        mainSheet.dataValidations.add(`J2:J${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: [`'참조'!$${hazardColLetter}$2:$${hazardColLetter}$${hazardNames.length + 1}`],
          showErrorMessage: true,
          errorTitle: '유효하지 않은 값',
          error: '목록에서 선택하세요.',
        });
      }
      // 보호구(K) — 복수 선택(쉼표 구분) 허용 위해 하드 검증 없이 드롭다운은 참고용으로만 제공
      if (protectionNames.length > 0) {
        mainSheet.dataValidations.add(`K2:K${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: [`'참조'!$${protectionColLetter}$2:$${protectionColLetter}$${protectionNames.length + 1}`],
          showErrorMessage: false, // 쉼표(,)로 복수 입력 허용 (드롭박스는 참고용)
        });
      }
      // 작업도구(L) — 복수 선택(쉼표 구분) 허용 위해 하드 검증 없이 드롭다운은 참고용으로만 제공
      if (toolNames.length > 0) {
        mainSheet.dataValidations.add(`L2:L${ROW_LIMIT}`, {
          type: 'list',
          allowBlank: true,
          formulae: [`'참조'!$${toolColLetter}$2:$${toolColLetter}$${toolNames.length + 1}`],
          showErrorMessage: false, // 쉼표(,)로 복수 입력 허용 (드롭박스는 참고용)
        });
      }
      // 위험도(N)
      mainSheet.dataValidations.add(`N2:N${ROW_LIMIT}`, {
        type: 'list',
        allowBlank: true,
        formulae: ['"상,중,하"'],
        showErrorMessage: true,
        errorTitle: '유효하지 않은 값',
        error: '상/중/하 중에서 선택하세요.',
      });
      // 위험도 조건부 서식 (상=빨강, 중=노랑, 하=초록)
      mainSheet.addConditionalFormatting({
        ref: `N2:N${ROW_LIMIT}`,
        rules: [
          { type: 'containsText', operator: 'containsText', text: '상', style: { fill: { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFEB5757' } }, font: { color: { argb: 'FFFFFFFF' }, bold: true } }, priority: 1 },
          { type: 'containsText', operator: 'containsText', text: '중', style: { fill: { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFF2C94C' } }, font: { color: { argb: 'FF5A4500' }, bold: true } }, priority: 2 },
          { type: 'containsText', operator: 'containsText', text: '하', style: { fill: { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FF27AE60' } }, font: { color: { argb: 'FFFFFFFF' }, bold: true } }, priority: 3 },
        ],
      });

      // 가이드 시트
      const guideSheet = workbook.addWorksheet('가이드');
      guideSheet.getColumn(1).width = 10;
      guideSheet.getColumn(2).width = 14;
      guideSheet.getColumn(3).width = 60;
      guideSheet.getColumn(4).width = 16;
      guideSheet.getColumn(5).width = 28;
      const guideTitle = guideSheet.addRow(['■ 위험성 수준 및 판단 기준 예시']);
      guideTitle.font = { bold: true, size: 12 };
      guideSheet.mergeCells(`A${guideTitle.number}:E${guideTitle.number}`);
      const guideHeader = guideSheet.addRow(['위험성 수준', '', '판단 기준', '허용 가능 여부', 'TO DO']);
      guideSheet.mergeCells(`A${guideHeader.number}:B${guideHeader.number}`);
      guideHeader.font = { bold: true };
      guideHeader.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      guideHeader.eachCell((c) => {
        c.border = { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
      });
      const guideRows = [
        { level: '상', label: '매우 높음', criteria: '- 사고 발생 시 사망 또는 장애가 남을 수 있는 위험\n- 산업안전보건법에 따른 기준을 만족하지 못하는 경우', allow: '허용 불가능', todo: '추가 안전보건조치 작성', color: 'FFEB5757', textColor: 'FFFFFFFF' },
        { level: '중', label: '보통', criteria: '- 사고 발생 시 요양이 필요한 위험\n- 아차사고 사례가 있는 경우', allow: '', todo: '', color: 'FFF2C94C', textColor: 'FF5A4500' },
        { level: '하', label: '매우 낮음', criteria: '- 작업 수행에 영향을 미치지 않는 경미한 부상 또는 질병이 예상되는 경우', allow: '허용 가능', todo: '현재의 안전보건조치 이행', color: 'FF27AE60', textColor: 'FFFFFFFF' },
      ];
      const guideRowRefs = [];
      guideRows.forEach((g) => {
        const r = guideSheet.addRow([g.level, g.label, g.criteria, g.allow, g.todo]);
        r.alignment = { vertical: 'middle', wrapText: true };
        r.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
        r.getCell(2).alignment = { vertical: 'middle', horizontal: 'center' };
        r.getCell(4).alignment = { vertical: 'middle', horizontal: 'center' };
        r.getCell(5).alignment = { vertical: 'middle', horizontal: 'center' };
        r.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: g.color } };
        r.getCell(1).font = { bold: true, color: { argb: g.textColor } };
        r.height = 36;
        r.eachCell((c) => {
          c.border = { top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' }, right: { style: 'thin' } };
        });
        guideRowRefs.push(r.number);
      });
      // 허용가능 여부/TO DO 상+중 병합
      guideSheet.mergeCells(`D${guideRowRefs[0]}:D${guideRowRefs[1]}`);
      guideSheet.mergeCells(`E${guideRowRefs[0]}:E${guideRowRefs[1]}`);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '작업계획_템플릿.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    triggerScheduleUpload() {
      if (this.$refs.scheduleExcelInput) {
        this.$refs.scheduleExcelInput.click();
      }
    },
    handleScheduleUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'array', cellDates: true });
        const sheet = workbook.Sheets['작업계획'] || workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
        if (!rows || rows.length < 2) return;

        const headerRow = rows[0] || [];
        const normalize = (v) => String(v || '').replace(/\s+/g, '');
        const findIdx = (label, fallback) => {
          const t = normalize(label);
          const i = headerRow.findIndex((c) => normalize(c).includes(t));
          return i > -1 ? i : fallback;
        };
        const colIdx = {
          region: findIdx('구분', 0),
          building: findIdx('관', 1),
          floor: findIdx('층', 2),
          detailLocation: findIdx('상세위치', 3),
          startDate: findIdx('작업시작일', 4),
          endDate: findIdx('작업종료일', 5),
          workItem: findIdx('작업항목', 6),
          procedure: findIdx('작업절차', 7),
          riskFactor: findIdx('위험요인', 8),
          hazard: findIdx('재해유형', 9),
          protection: findIdx('보호구', 10),
          tool: findIdx('작업도구', 11),
          currentSafety: findIdx('현재안전보건조치', 12),
          riskLevel: findIdx('위험도', 13),
          additionalSafety: findIdx('추가안전보건조치', 14),
        };

        const importedScheduleRows = [];
        const importedWorkRows = [];
        rows.slice(1).forEach((row) => {
          const regionName = String(row[colIdx.region] || '').trim();
          const buildingName = String(row[colIdx.building] || '').trim();
          const floorName = String(row[colIdx.floor] || '').trim();
          const detailLocation = String(row[colIdx.detailLocation] || '').trim();
          const workItem = String(row[colIdx.workItem] || '').trim();
          const startDate = this.normalizeDateValue(row[colIdx.startDate]);
          const endDate = this.normalizeDateValue(row[colIdx.endDate]);
          const procedure = String(row[colIdx.procedure] || '').trim();
          const riskFactor = String(row[colIdx.riskFactor] || '').trim();
          const hazardValue = String(row[colIdx.hazard] || '').trim();
          const protectionValue = String(row[colIdx.protection] || '').trim();
          const toolValue = String(row[colIdx.tool] || '').trim();
          const currentSafety = String(row[colIdx.currentSafety] || '').trim();
          const riskLevelRaw = String(row[colIdx.riskLevel] || '').trim();
          // 엑셀 값이 상/중/하가 아니면 화면 기본값과 동일하게 '하' 로 채운다(빈 값 방지)
          const riskLevel = ['상', '중', '하'].includes(riskLevelRaw) ? riskLevelRaw : '하';
          const additionalSafety = String(row[colIdx.additionalSafety] || '').trim();

          const isEmpty = !regionName && !buildingName && !floorName && !detailLocation && !workItem
            && !startDate && !endDate && !procedure && !riskFactor && !hazardValue && !protectionValue && !toolValue
            // riskLevel 은 기본값 '하' 로 채워지므로 빈 행 판정에는 원본 값(riskLevelRaw)을 쓴다
            && !currentSafety && !riskLevelRaw && !additionalSafety;
          if (isEmpty) return;

          const region = this.scheduleRegions.find((r) => r.locationName === regionName);
          const regionCode = region ? region.locationCode : '';
          let buildingCode = '';
          let floorCode = '';
          let detailCode = '';
          let detailContent = ''; // '기타' 등 목록 밖 자유입력 상세위치 내용만 보존
          if (region) {
            const buildings = (region.children || []).filter((b) => b.isDeleteYN == "N");
            const building = buildings.find((b) => b.locationName === buildingName);
            buildingCode = building ? building.locationCode : '';
            if (building) {
              const floors = (building.children || []).filter((f) => f.isDeleteYN == "N");
              const floor = floors.find((f) => f.locationName === floorName);
              floorCode = floor ? floor.locationCode : '';
              if (floor) {
                const details = (floor.children || []).filter((d) => d.isDeleteYN == "N");
                const detail = details.find((d) => d.locationName === detailLocation);
                if (detail) {
                  detailCode = detail.locationCode; // 정규 위치 정확 매칭 (기타 내용 없음)
                } else if (detailLocation) {
                  // 정규 상세위치 목록에 없는 자유입력 → 해당 층에 '기타' 옵션이 있으면 기타로 매핑.
                  // 내용은 detailContent 에 보존 → 화면 재현 시 기타 입력란에 표시(완전 왕복).
                  const etc = details.find((d) => String(d.locationName).trim() === '기타');
                  detailCode = etc ? etc.locationCode : '';
                  detailContent = detailLocation;
                }
              }
            }
          }

          const newSchedule = this.createScheduleRow();
          newSchedule.regionCode = regionCode;
          newSchedule.buildingCode = buildingCode;
          newSchedule.floorCode = floorCode;
          newSchedule.detailCode = detailCode;
          newSchedule.detailLocation = detailContent;
          newSchedule.workItem = workItem;
          newSchedule.startDate = startDate;
          newSchedule.endDate = endDate;
          // 업로드 데이터는 그대로 신뢰. handleStartDateChange 를 호출하면
          // startDate 가 startDateMin(오늘+7일) 이전인 경우 endDate 가 비워져 표시 안 됨.
          importedScheduleRows.push(newSchedule);

          const hazardOpt = hazardValue ? (this.matchOption(this.hazardOptions, hazardValue) || '') : '';
          const protectionOpt = protectionValue ? (this.matchOption(this.protectionOptions, protectionValue) || '') : '';
          const toolOpt = toolValue ? (this.matchOption(this.toolOptions, toolValue) || '') : '';

          const newWorkRow = this.createRow();
          newWorkRow.scheduleRowId = newSchedule.id;
          newWorkRow.item = workItem;
          newWorkRow.startDate = startDate;
          newWorkRow.endDate = endDate;
          newWorkRow.sets = [{
            ...this.createSet(),
            procedure,
            riskFactor,
            hazard: hazardOpt,
            protection: protectionOpt,
            tool: toolOpt,
            currentSafety,
            riskLevel,
            additionalSafety,
          }];
          importedWorkRows.push(newWorkRow);
        });

        const imported = importedScheduleRows;
        if (imported.length > 0) {
          // 겹침 판정키 = 위치 + 작업항목 + 일정. (엑셀 내부 중복은 검증하지 않고, 기존에 이미 있는 행과 겹치는 업로드 행만 제외)
          const keyOf = (r) => [r.regionCode || '', r.buildingCode || '', r.floorCode || '',
            r.detailCode || '', String(r.detailLocation || '').trim(),
            String(r.workItem || '').trim(), String(r.startDate || '').trim(), String(r.endDate || '').trim()].join('|');

          // 엑셀 내부 중복 제거 안 함 → 업로드 행은 전부 후보로 유지 (work 행은 원래 링크 그대로)
          const keptImported = imported;
          const keptWork = importedWorkRows;

          // 업로드된 IDC(구분) 판별 + 상단 작업위치 선택 키 목록
          const firstRegion = keptImported.find((r) => r.regionCode);
          const targetIdc = (firstRegion && firstRegion.regionCode) || this.selectedIdcCode;
          const idcChanged = !!(targetIdc && targetIdc !== this.selectedIdcCode);
          const locKeys = keptImported
            .filter((r) => r.regionCode && r.buildingCode && r.floorCode && r.detailCode)
            .map((r) => `${r.regionCode}|${r.buildingCode}|${r.floorCode}|${r.detailCode}`);

          const apply = () => {
            // 기존 스케줄/위험성평가는 그대로 유지. IDC 바뀌면 기존 폐기.
            let baseSchedule = [];
            let baseWork = [];
            if (!idcChanged) {
              baseSchedule = (this.scheduleRows.length === 1 && this.isEmptyScheduleRow(this.scheduleRows[0]))
                ? [] : this.scheduleRows.slice();
              baseWork = (this.rows.length === 1 && this.isEmptyWorkRow(this.rows[0]))
                ? [] : this.rows.slice();
            }
            // 기존 행과 겹치는(위치+작업항목+일정 동일) 업로드 행만 제외하고 추가
            const existingKeys = new Set(baseSchedule.map(keyOf));
            const toAdd = keptImported.filter((r) => !existingKeys.has(keyOf(r)));
            const toAddIds = new Set(toAdd.map((r) => r.id));
            const toAddWork = keptWork.filter((wr) => toAddIds.has(wr.scheduleRowId));
            this.scheduleRows = baseSchedule.concat(toAdd);
            this.rows = baseWork.concat(toAddWork);

            // 3) 업로드된 위치를 상단 작업위치 선택에 반영(합집합)
            if (locKeys.length) {
              const merged = new Set(this.selectedFloorKeys || []);
              locKeys.forEach((k) => merged.add(k));
              this.selectedFloorKeys = Array.from(merged);
            }
          };

          if (idcChanged) {
            // IDC 변경 → watcher 가 selectedFloorKeys/scheduleRows 리셋하므로 그 이후에 반영
            this.selectedIdcCode = targetIdc;
            this.$nextTick(apply);
          } else {
            apply();
          }
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = '';
    },
    isEmptyScheduleRow(row) {
      if (!row) return true;
      // regionCode 는 선택된 IDC 로 자동 설정되는 값이라 빈 행 판정에서 제외
      // (제외하지 않으면 업로드 시 기본 빈 행이 남아 빈 열이 하나 더 생김)
      return !row.buildingCode && !row.floorCode && !row.detailCode &&
             !row.detailLocation && !row.workItem && !row.startDate && !row.endDate;
    },
    addRow() {
      this.rows.push(this.createRow());
    },
    copyRows() {
      const copies = this.rows
        .filter((row) => row.checked)
        .map((row) => ({
          ...JSON.parse(JSON.stringify(row)),
          id: this.createRowId(),
          checked: false,
        }));
      const lastCheckedIdx = this.rows.reduce((acc, row, idx) => (row.checked ? idx : acc), -1);
      this.rows.splice(lastCheckedIdx + 1, 0, ...copies);
    },
    applyScheduleToRows() {
      const validScheduleRows = this.scheduleRows.filter(
        (row) => row.workItem || row.startDate || row.endDate
      );
      const existingMap = {};
      this.rows.forEach((row) => {
        if (row.scheduleRowId) existingMap[row.scheduleRowId] = row;
      });
      this.rows = validScheduleRows.map((sRow) => {
        const existing = existingMap[sRow.id];
        if (existing) {
          existing.item = sRow.workItem || '';
          existing.startDate = sRow.startDate || '';
          existing.endDate = sRow.endDate || '';
          return existing;
        }
        const row = this.createRow();
        row.scheduleRowId = sRow.id;
        row.item = sRow.workItem || '';
        row.startDate = sRow.startDate || '';
        row.endDate = sRow.endDate || '';
        return row;
      });
      // 예정공정표가 비어 있으면 작업항목도 비운다(깨끗한 빈 행 1개 = 아무것도 입력 안 된 상태).
      if (this.rows.length === 0) this.rows = [this.createRow()];
    },
    removeRows() {
      this.rows = this.rows.filter((row) => !row.checked);
      if (this.rows.length === 0) {
        this.rows.push(this.createRow());
      }
    },
    resetRows() {
      this.rows = [this.createRow()];
    },
    addEquipmentStatusRow() {
      this.equipmentStatusRows.push(this.createEquipmentStatusRow());
    },
    removeEquipmentStatusRows() {
      this.equipmentStatusRows = this.removeChecked(this.equipmentStatusRows, this.createEquipmentStatusRow);
    },
    addWorkerRow() {
      this.workerRows.push(this.createWorkerRow());
    },
    removeWorkerRows() {
      this.workerRows = this.removeChecked(this.workerRows, this.createWorkerRow);
    },
    addRiskRow() {
      this.riskRows.push(this.createRiskRow());
    },
    removeRiskRows() {
      this.riskRows = this.removeChecked(this.riskRows, this.createRiskRow);
    },
    addCargoRow() {
      this.cargoRows.push(this.createCargoRow());
    },
    removeCargoRows() {
      this.cargoRows = this.removeChecked(this.cargoRows, this.createCargoRow);
    },
    removeChecked(list, createFn) {
      const next = list.filter((row) => !row.checked);
      return next.length > 0 ? next : [createFn.call(this)];
    },
    // 위치선택: 해당 층의 상세위치 전부 선택됨 여부
    isFloorAllSelected(row) {
      if (!row || !row.details || !row.details.length) return false;
      return row.details.every((d) => this.selectedFloorKeys.includes(d.key));
    },
    // 위치선택: 해당 층 상세위치 전체 선택/해제 토글
    toggleFloorAll(row) {
      if (!row || !row.details || !row.details.length) return;
      const keys = row.details.map((d) => d.key);
      if (this.isFloorAllSelected(row)) {
        this.selectedFloorKeys = this.selectedFloorKeys.filter((k) => !keys.includes(k));
      } else {
        const set = new Set(this.selectedFloorKeys || []);
        keys.forEach((k) => set.add(k));
        this.selectedFloorKeys = Array.from(set);
      }
    },
    // 아래 change 핸들러들: Dropdown 은 업로드/불러오기로 값을 프로그램적으로 세팅할 때도
    // @changeValue 를 emit 한다. 무조건 하위를 리셋하면 그 순간 detailCode/detailLocation 이
    // 지워져(캐스케이드) 업로드 데이터가 유실된다. 그래서 "현재 하위 값이 새 상위의 하위 목록에
    // 유효하면 유지하고, 무효할 때만 초기화"한다 → 실제 사용자 변경만 리셋(타이밍 독립적).
    handleScheduleRegionChange(row) {
      if (!this.getScheduleBuildings(row).some((b) => b.locationCode === row.buildingCode)) {
        row.buildingCode = '';
      }
      this.handleScheduleBuildingChange(row);
    },
    handleScheduleBuildingChange(row) {
      if (!this.getScheduleFloors(row).some((f) => f.locationCode === row.floorCode)) {
        row.floorCode = '';
      }
      this.handleScheduleFloorChange(row);
    },
    handleScheduleFloorChange(row) {
      if (!this.getScheduleDetails(row).some((d) => d.locationCode === row.detailCode)) {
        row.detailCode = '';
        row.detailLocation = '';
      }
    },
    getScheduleBuildings(row) {
      if (!row || !row.regionCode) return [];
      const region = this.scheduleRegions.find((item) => item.locationCode === row.regionCode);
      if (!region || !region.children) return [];
      const allow = this.allowedScheduleLocations.buildings;
      return region.children.filter((item) => item.isDeleteYN == "N" && allow.has(item.locationCode));
    },
    getScheduleFloors(row) {
      if (!row || !row.buildingCode) return [];
      const buildings = this.getScheduleBuildings(row);
      const building = buildings.find((item) => item.locationCode === row.buildingCode);
      if (!building || !building.children) return [];
      const allow = this.allowedScheduleLocations.floors;
      return building.children.filter((item) => item.isDeleteYN == "N"
        && allow.has(row.buildingCode + '|' + item.locationCode));
    },
    getScheduleDetails(row) {
      if (!row || !row.floorCode) return [];
      const floors = this.getScheduleFloors(row);
      const floor = floors.find((item) => item.locationCode === row.floorCode);
      if (!floor || !floor.children) return [];
      const allow = this.allowedScheduleLocations.details;
      return floor.children.filter((item) => item.isDeleteYN == "N"
        && allow.has(row.buildingCode + '|' + row.floorCode + '|' + item.locationCode));
    },
    getScheduleRegionName(row) {
      const region = this.scheduleRegions.find((item) => item.locationCode === row.regionCode);
      return region ? region.locationName : '-';
    },
    getScheduleBuildingName(row) {
      if (!row || !row.regionCode) return '-';
      const building = this.getScheduleBuildings(row).find((item) => item.locationCode === row.buildingCode);
      return building ? building.locationName : '-';
    },
    getScheduleFloorName(row) {
      if (!row || !row.buildingCode) return '-';
      const floor = this.getScheduleFloors(row).find((item) => item.locationCode === row.floorCode);
      return floor ? floor.locationName : '-';
    },
    getScheduleDetailName(row) {
      if (!row || !row.floorCode) return row.detailLocation || '-';
      const detail = this.getScheduleDetails(row).find((item) => item.locationCode === row.detailCode);
      return detail ? detail.locationName : (row.detailLocation || '-');
    },
    getTimelineMeta(row) {
      const totalDays = this.scheduleTimelineDays.length;
      if (!this.scheduleTimelineRange || totalDays === 0) {
        return { offset: 0, length: 0, remaining: 0, valid: false };
      }
      const start = this.parseDate(row.startDate);
      const end = this.parseDate(row.endDate);
      if (!start || !end || end < start) {
        return { offset: 0, length: 0, remaining: totalDays, valid: false };
      }
      const rangeStart = this.toStartOfDay(this.scheduleTimelineRange.start);
      let offset = this.diffDays(rangeStart, start);
      let length = this.diffDays(start, end) + 1;
      if (offset < 0) {
        length += offset;
        offset = 0;
      }
      if (offset >= totalDays || length <= 0) {
        return { offset: 0, length: 0, remaining: totalDays, valid: false };
      }
      if (offset + length > totalDays) {
        length = totalDays - offset;
      }
      const remaining = totalDays - offset - length;
      return {
        offset,
        length,
        remaining,
        valid: length > 0
      };
    },
    getTimelineColor(index) {
      if (!this.scheduleTimelineColors.length) return '#2F80ED';
      return this.scheduleTimelineColors[index % this.scheduleTimelineColors.length];
    },
    hasCheckedRows(list) {
      return list.some((row) => row.checked);
    },
    resetHeavyEquipmentData() {
      this.equipmentTypes = [];
      this.equipmentStatusRows = [this.createEquipmentStatusRow()];
      this.workerRows = [this.createWorkerRow()];
      this.signalMethod = '';
      this.riskRows = [this.createRiskRow()];
      this.transportMap = '';
      this.cargoRows = [this.createCargoRow()];
      this.layoutFiles = [];
    },
    handleLayoutFiles(event) {
      const files = Array.from(event.target.files || []);
      this.layoutFiles = files;
    },
    async handleInsuranceFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        this.insuranceFile = null;
        return;
      }
      if (!this.planId) {
        // planId 미발급 상태면 임시 보관 (next-plan-id 가 mount 시 발급되므로 거의 없음)
        this.insuranceFile = file;
        if (event.target) event.target.value = '';
        return;
      }
      try {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('permitType', 'insurance');
        fd.append('docKey', 'insurance');
        const res = await this.$http.post(
          '/api/public/work-permit/' + encodeURIComponent(this.planId) + '/file',
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }
        );
        const meta = res && res.data && res.data.payload;
        if (meta && meta.id) {
          this.insuranceFile = {
            id: meta.id,
            name: meta.fileName || file.name,
            size: meta.fileSize || file.size,
            uploadedAt: meta.uploadedAt || Date.now()
          };
          this.noti('업로드 완료', '산재보험가입증명서가 업로드되었습니다.', 'success');
        } else {
          this.insuranceFile = file;
          this.noti('업로드 응답 이상', (res && res.data && res.data.message) || '서버 응답을 확인해 주세요.', 'warning');
        }
      } catch (e) {
        console.log('insurance upload 실패', e);
        this.insuranceFile = file; // 임시 보관 (사용자 재시도 유도)
        this.noti('업로드 오류', '산재보험가입증명서 업로드 중 오류가 발생했습니다.', 'danger');
      } finally {
        if (event.target) event.target.value = '';
      }
    },
    goToPermitAgree() {
      this.$router.push({ path: '/app/workPermit/agree' });
    },
    // 위험도가 상/중인데 추가 안전보건조치가 비어 있으면 필수 입력 대상
    isAdditionalSafetyRequired(set) {
      if (!set) return false;
      const level = (set.riskLevel || '').trim();
      const measure = (set.additionalSafety || '').trim();
      return (level === '상' || level === '중') && !measure;
    },
    // 상/중 위험도 항목의 추가 안전보건조치 누락 검증 (없으면 첫 누락 위치 반환)
    findMissingAdditionalSafety() {
      const rows = this.rows || [];
      for (let ri = 0; ri < rows.length; ri++) {
        const sets = (rows[ri] && rows[ri].sets) || [];
        for (let si = 0; si < sets.length; si++) {
          if (this.isAdditionalSafetyRequired(sets[si])) {
            return { row: ri + 1, set: si + 1, level: (sets[si].riskLevel || '').trim() };
          }
        }
      }
      return null;
    },
    // 이전 허가서 불러오기 목록의 상태 한글 표기
    reusableStatusText(s) {
      const map = { DRAFT: '임시저장', SUBMITTED: '제출', NTREE_PENDING: '결재중', APPROVED: '승인', REJECTED: '반려' };
      return map[s] || (s || '-');
    },
    async goToPermitCheck() {
      // "다음" 시 BE 에 DRAFT 로 임시저장하고 응답 받은 planId 로 화면 동기화한 뒤
      // 확인 페이지에 planId 를 들고 이동. (최종 "신청"은 Check 페이지에서 호출.)
      // 0) 작업 기본정보 필수값 검증 (별표(ess) 표시 필드)
      const baseMiss = [];
      if (!(this.planDateRange && this.planDateRange.length === 2
        && this.planDateRange[0] && this.planDateRange[1])) baseMiss.push('전체 작업 일정');
      if (!String(this.planName || '').trim()) baseMiss.push('작업 명');
      if (!String(this.companyName || '').trim()) baseMiss.push('업체명');
      if (!String(this.workManager || '').trim()) baseMiss.push('작업 지휘자');
      if (!String(this.workManagerPhone || '').trim()) baseMiss.push('작업 지휘자 연락처');
      if (!(Number(this.workPeopleCount) > 0)) baseMiss.push('작업인원');
      if (!String(this.safetyManager || '').trim()) baseMiss.push('안전담당자');
      if (!String(this.safetyManagerPhone || '').trim()) baseMiss.push('안전담당자 연락처');
      if (!(Array.isArray(this.selectedFloorKeys) && this.selectedFloorKeys.length > 0)) baseMiss.push('작업 위치');
      if (baseMiss.length) {
        this.noti('입력 필요', `작업 기본정보 필수 항목을 입력해야 합니다: ${baseMiss.join(', ')}`, 'warning');
        return;
      }
      const missing = this.findMissingAdditionalSafety();
      if (missing) {
        this.noti('입력 필요',
          `위험도가 상/중인 작업 항목은 추가 안전보건조치를 반드시 입력해야 합니다. (${missing.row}번째 작업 항목 확인)`,
          'warning');
        return;
      }
      // 고소작업: '기타 고소작업대' 선택 시 내용 필수
      if (this.highRiskTargets.includes('고소작업')
        && this.highAltitudePermit.isOther
        && !String(this.highAltitudePermit.otherText || '').trim()) {
        this.noti('입력 필요', '고소작업 허가서에서 "기타 고소작업대" 선택 시 내용을 반드시 입력해야 합니다.', 'warning');
        return;
      }
      // 화기작업: '기타 화기작업' 선택 시 내용 필수
      if (this.highRiskTargets.includes('화기작업')
        && this.fireWorkPermit.isOther
        && !String(this.fireWorkPermit.otherText || '').trim()) {
        this.noti('입력 필요', '화기작업 허가서에서 "기타 화기작업" 선택 시 내용을 반드시 입력해야 합니다.', 'warning');
        return;
      }
      // 화기작업: 화재감시자·연락처 필수
      if (this.highRiskTargets.includes('화기작업')) {
        const fp = this.fireWorkPermit;
        const need = [];
        if (!String(fp.fireWatcher || '').trim()) need.push('화재감시자');
        if (!String(fp.fireWatcherPhone || '').trim()) need.push('화재감시자 연락처');
        if (need.length) {
          this.noti('입력 필요', '화기작업 허가서의 다음 항목은 필수입니다: ' + need.join(', '), 'warning');
          return;
        }
        if (!/^0\d{1,2}-\d{3,4}-\d{4}$/.test(String(fp.fireWatcherPhone).trim())) {
          this.noti('입력 확인', '화재감시자 연락처 형식이 올바르지 않습니다.', 'warning');
          return;
        }
      }
      // 밀폐공간: '기타 밀폐공간' 선택 시 내용 필수
      if (this.highRiskTargets.includes('밀폐공간')
        && this.confinedSpacePermit.isOther
        && !String(this.confinedSpacePermit.otherText || '').trim()) {
        this.noti('입력 필요', '밀폐공간 허가서에서 "기타 밀폐공간" 선택 시 내용을 반드시 입력해야 합니다.', 'warning');
        return;
      }
      // 전기작업: 필수 항목 검증
      if (this.highRiskTargets.includes('전기작업')) {
        const p = this.electricWorkPermit;
        const need = [];
        if (!p.liveLineWork) need.push('활선 작업여부');
        if (!(p.workPeriod && p.workPeriod.length === 2 && p.workPeriod[0] && p.workPeriod[1])) need.push('작업기간');
        if (!String(p.workScope || '').trim()) need.push('작업범위');
        if (!(p.workers || []).some((w) => String(w.name || '').trim() && String(w.qualification || '').trim())) need.push('작업자 자격확인');
        if (!String(p.approachDistance || '').trim()) need.push('접근 한계거리');
        if (!String(p.measurementEquip || '').trim()) need.push('측정장비');
        if (!String(p.liveLineEquip || '').trim()) need.push('활선기구/장비');
        if (!String(p.defenseEquip || '').trim()) need.push('방호구');
        if (!(p.procedures || []).some((pr) => String(pr.item || '').trim() || String(pr.procedure || '').trim())) need.push('작업순서 및 안전작업방법');
        if (need.length) {
          this.noti('입력 필요', `전기작업 허가서의 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 화학물질: 선택 시 취급화학물질 1건 이상 + 각 행의 위험성·MSDS 첨부 필수
      if (this.highRiskTargets.includes('화학물질')) {
        const chems = this.chemicalPermit.chemicals || [];
        const inUse = (c) => !!(String(c.name || '').trim() || String(c.handlingMethods || '').trim()
          || String(c.hazard || '').trim() || (c.msdsFiles && c.msdsFiles.length));
        if (!chems.some(inUse)) {
          this.noti('입력 필요', '화학물질 허가서에 취급화학물질을 1건 이상 입력하고 위험성·MSDS를 첨부해야 합니다.', 'warning');
          return;
        }
        for (let i = 0; i < chems.length; i++) {
          const c = chems[i];
          if (!inUse(c)) continue; // 완전히 빈 행은 무시
          if (!String(c.hazard || '').trim()) {
            this.noti('입력 필요', `화학물질 허가서 ${i + 1}번 항목의 위험성을 입력해야 합니다. (MSDS의 2번 유해·위험성 참고)`, 'warning');
            return;
          }
          if (!(c.msdsFiles && c.msdsFiles.length)) {
            this.noti('입력 필요', `화학물질 허가서 ${i + 1}번 항목의 MSDS 파일을 첨부해야 합니다.`, 'warning');
            return;
          }
        }
      }
      // 운전중작업: 운전중 작업설비 각 행 설비명·작업내용 필수 (1건 이상)
      if (this.highRiskTargets.includes('운전중작업')) {
        const facs = this.operatingWorkPermit.facilities || [];
        const inUse = (r) => !!(String(r.facilityName || '').trim() || String(r.workScope || '').trim() || String(r.workContent || '').trim());
        if (!facs.some(inUse)) {
          this.noti('입력 필요', '운전중작업 허가서에 운전중 작업설비를 1건 이상 입력하고 설비명·작업내용을 작성해야 합니다.', 'warning');
          return;
        }
        for (let i = 0; i < facs.length; i++) {
          const r = facs[i];
          if (!inUse(r)) continue;
          const miss = [];
          if (!String(r.facilityName || '').trim()) miss.push('설비명');
          if (!String(r.workContent || '').trim()) miss.push('작업내용');
          if (miss.length) {
            this.noti('입력 필요', `운전중 작업설비 ${i + 1}번 항목의 ${miss.join('·')}을(를) 입력해야 합니다.`, 'warning');
            return;
          }
        }
      }
      // 중량물취급: 운반방법별 필수 항목
      if (this.highRiskTargets.includes('중량물취급')) {
        const p = this.heavyLiftPermit;
        const methods = p.transportMethods || [];
        const need = [];
        if (methods.includes('기계·장비 사용')) {
          (p.equipmentList || []).forEach((e, i) => {
            const miss = [];
            if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
            if (!String(e.modelName || '').trim()) miss.push('장비명');
            if (!String(e.registrationNo || '').trim()) miss.push('등록번호');
            if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
            if (!String(e.capacity || '').trim()) miss.push('규격');
            if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
          });
        }
        if (methods.includes('줄걸이 용구 등 사용')) {
          (p.liftingList || []).forEach((l, i) => {
            const miss = [];
            if (!String(l.safeWorkLoad || '').trim()) miss.push('안전작업하중');
            if (!String(l.maxWorkLoad || '').trim()) miss.push('최대사용하중');
            if (miss.length) need.push(`줄걸이 ${i + 1}(${miss.join('/')})`);
          });
        }
        if (methods.length > 0) {
          (p.cargoList || []).forEach((c, i) => {
            if (!String(c.totalWeight || '').trim()) need.push(`중량물 ${i + 1}(총중량 - 총 양중수량·1회 양중중량 입력)`);
          });
        }
        if (need.length) {
          this.noti('입력 필요', `중량물 작업계획 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 지게차: 장비별 필수 + 지반조사(지반종류/지반상태/함수상태) + 허용하중 + 화물/적재 필수
      if (this.heavyWorkTypes.includes('지게차')) {
        const p = this.forkliftPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
          if (!String(e.modelName || '').trim()) miss.push('장비명');
          if (!String(e.registrationNo || '').trim()) miss.push('등록번호');
          if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
          if (!String(e.machineSpec || '').trim()) miss.push('규격');
          if (!String(e.mastHeight || '').trim()) miss.push('마스트 높이');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        if (!((si.groundTypes && si.groundTypes.length) || (si.groundTypeOther && String(si.groundTypeOtherText || '').trim()))) need.push('지반 종류');
        if (si.groundTypeOther && !String(si.groundTypeOtherText || '').trim()) need.push('지반 종류 기타');
        if (!(si.conditions && si.conditions.length)) need.push('지반 상태');
        if (si.slopeCheck && !String(si.slopeText || '').trim()) need.push('경사');
        if (si.specialNoteCheck && !String(si.specialNoteText || '').trim()) need.push('특이사항');
        if (!si.groundwaterStatus) need.push('지하수위 등 함수상태');
        if (!((si.reinforcementMethods && si.reinforcementMethods.length) || (si.reinforcementOther && String(si.reinforcementOtherText || '').trim()))) need.push('지반 보강방법');
        if (si.reinforcementOther && !String(si.reinforcementOtherText || '').trim()) need.push('지반 보강방법 기타');
        const cal = p.cargoAndLoad || {};
        if (!String(cal.forkliftCapacity || '').trim()) need.push('지게차 허용하중');
        const cargo = cal.cargo || {};
        if (!String(cargo.name || '').trim()) need.push('화물 품명');
        if (!(String(cargo.type || '').trim() && String(cargo.shape || '').trim())) need.push('화물 종류/형상');
        if (!String(cargo.qtyPerTrip || '').trim()) need.push('1회 운반수량');
        if (!String(cargo.weightPerTrip || '').trim()) need.push('1회 운반중량');
        const loading = cal.loading || {};
        if (!String(loading.stackHeight || '').trim()) need.push('적재 높이');
        if (!String(loading.stackWidth || '').trim()) need.push('적재 너비');
        if (!String(loading.minPathHeight || '').trim()) need.push('작업장·통로 최소 높이');
        if (!String(loading.minPathWidth || '').trim()) need.push('작업장·통로 최소 너비');
        // 작업순서 및 안전작업방법: 위험요인·현재 안전보건조치가 모두 채워진 행이 최소 1개 필요
        const hasValidProc = (p.procedures || []).some((pr) =>
          String(pr.riskFactor || '').trim() && String(pr.currentMeasure || '').trim());
        if (!hasValidProc) need.push('작업순서(위험요인·현재 안전보건조치)');
        if (need.length) {
          this.noti('입력 필요', `지게차 작업계획서 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 이동식크레인: 장비별 필수 (건설기계등록증/자동차등록번호/보험여부/최대작업높이/정격하중)
      if (this.heavyWorkTypes.includes('이동식크레인작업')) {
        const p = this.mobileCranePermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
          if (e.equipType) { // 장비 종류 선택된 경우에만 하위 필드 검증(미선택 시 입력 UI 없음)
            if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
            if (e.equipType === '카고크레인') {
              if (!String(e.vehicleRegNo || '').trim()) miss.push('자동차등록번호');
              if (!String(e.maxWorkHeight || '').trim()) miss.push('최대 작업높이');
              if (!String(e.ratedLoad || '').trim()) miss.push('정격하중');
            } else if (e.equipType === '기중기') {
              if (!String(e.machineName || '').trim()) miss.push('건설기계명');
              if (!String(e.machineSpec || '').trim()) miss.push('규격');
              if (!String(e.standardBoomRadius || '').trim()) miss.push('표준붐의 작업반경');
              if (!String(e.boomLengthMax || '').trim()) miss.push('붐길이');
              if (!String(e.boomMaxAngle || '').trim()) miss.push('붐의 최대각도');
              if (!String(e.maxRatedLoad || '').trim()) miss.push('최대정격');
              if (!String(e.boomMinAngle || '').trim()) miss.push('붐의 최소각도');
            }
          }
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        if (need.length) {
          this.noti('입력 필요', `이동식크레인 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 차량계하역운반기계: 장비별 필수 + 지반 종류/상태/보강방법
      if (this.heavyWorkTypes.includes('차량계하역운반기계')) {
        const p = this.cargoEquipPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
          if (!String(e.modelName || '').trim()) miss.push('장비명');
          if (!String(e.registrationNo || '').trim()) miss.push('등록번호');
          if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
          if (!String(e.loadCapacity || '').trim()) miss.push('적재함 용량');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        if (!((si.groundTypes && si.groundTypes.length) || (si.groundTypeOther && String(si.groundTypeOtherText || '').trim()))) need.push('지반 종류');
        if (si.groundTypeOther && !String(si.groundTypeOtherText || '').trim()) need.push('지반 종류 기타');
        if (!((si.conditions && si.conditions.length) || si.slopeCheck || si.specialNoteCheck)) need.push('지반 상태');
        if (si.slopeCheck && !String(si.slopeText || '').trim()) need.push('경사');
        if (si.specialNoteCheck && !String(si.specialNoteText || '').trim()) need.push('특이사항');
        if (!((si.reinforcementMethods && si.reinforcementMethods.length) || (si.reinforcementOther && String(si.reinforcementOtherText || '').trim()))) need.push('지반 보강방법');
        if (!((si.accessRestrictions && si.accessRestrictions.length) || (si.accessRestrictionOther && String(si.accessRestrictionOtherText || '').trim()))) need.push('작업반경 내 출입금지 조치');
        if (!si.nearbyPowerLines) need.push('주변 가공전선 접촉 가능 여부');
        if (!si.nearbyObstacle) need.push('주변 지장물 간섭 여부');
        if (need.length) {
          this.noti('입력 필요', `차량계하역운반기계 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 굴착작업: 장비별 필수 + 지하매설물조사(확인결과/조치여부)
      if (this.heavyWorkTypes.includes('굴착작업')) {
        const p = this.excavationPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
          if (!String(e.modelName || '').trim()) miss.push('장비명');
          if (!String(e.registrationNo || '').trim()) miss.push('등록번호');
          if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
          if (!String(e.driveType || '').trim()) miss.push('구동형식');
          if (!String(e.ratedLoad || '').trim()) miss.push('정격하중');
          if (!((e.workDevices && e.workDevices.length) || (e.workDeviceOther && String(e.workDeviceOtherText || '').trim()))) miss.push('작업장치');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        const ug = si.underground || [];
        ug.forEach((it) => {
          if (it.applicable !== true && it.applicable !== false) need.push(`지하매설물(${it.name}) 확인결과`);
          else if (it.applicable === true && !String(it.measure || '').trim()) need.push(`지하매설물(${it.name}) 조치여부`);
        });
        if (!String(si.requiredLoadCapacity || '').trim()) need.push('필요 지내력');
        if (!((si.reinforcementMethods && si.reinforcementMethods.length) || (si.reinforcementOther && String(si.reinforcementOtherText || '').trim()))) need.push('지반 보강방법');
        if (!((si.accessRestrictions && si.accessRestrictions.length) || (si.accessRestrictionOther && String(si.accessRestrictionOtherText || '').trim()))) need.push('작업반경 내 출입금지 조치');
        if (!si.nearbyPowerLines) need.push('주변 가공전선 접촉 가능 여부');
        if (!si.nearbyObstacle) need.push('주변 지장물 간섭 여부');
        if (si.groundTypeOther && !String(si.groundTypeOtherText || '').trim()) need.push('지반 종류 기타');
        if (si.slopeCheck && !String(si.slopeText || '').trim()) need.push('경사');
        if (si.specialNoteCheck && !String(si.specialNoteText || '').trim()) need.push('특이사항');
        if (need.length) {
          this.noti('입력 필요', `굴착작업 계획서 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 차량계건설기계 작업: 장비별 필수(등록증/장비명/보험/기계규격/기타제원) + 지형·지반 조사내용 체크/라디오 모두 필수
      if (this.heavyWorkTypes.includes('차량계건설기계 작업')) {
        const p = this.constrEquipPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (e.hasCertificate === null || e.hasCertificate === undefined || e.hasCertificate === '') miss.push('건설기계등록증');
          if (!String(e.modelName || '').trim()) miss.push('장비명');
          if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
          if (!String(e.machineSpec || '').trim()) miss.push('기계규격');
          if (!String(e.otherSpec || '').trim()) miss.push('기타 제원');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        if (!((si.groundTypes && si.groundTypes.length) || (si.groundTypeOther && String(si.groundTypeOtherText || '').trim()))) need.push('지반 종류');
        if (si.groundTypeOther && !String(si.groundTypeOtherText || '').trim()) need.push('지반 종류 기타');
        if (!(si.conditions && si.conditions.length)) need.push('지반 상태');
        if (si.slopeCheck && !String(si.slopeText || '').trim()) need.push('경사');
        if (si.specialNoteCheck && !String(si.specialNoteText || '').trim()) need.push('특이사항');
        if (!((si.reinforcementMethods && si.reinforcementMethods.length) || (si.reinforcementOther && String(si.reinforcementOtherText || '').trim()))) need.push('지반 보강방법');
        if (si.reinforcementOther && !String(si.reinforcementOtherText || '').trim()) need.push('지반 보강방법 기타');
        if (!((si.accessRestrictions && si.accessRestrictions.length) || (si.accessRestrictionOther && String(si.accessRestrictionOtherText || '').trim()))) need.push('작업반경 내 출입금지 조치');
        if (si.accessRestrictionOther && !String(si.accessRestrictionOtherText || '').trim()) need.push('출입금지 조치 기타');
        if (!si.nearbyPowerLines) need.push('주변 가공전선 접촉 가능 여부');
        if (si.nearbyPowerLines === '있음' && !String(si.nearbyPowerLinesMeasure || '').trim()) need.push('가공전선 조치내용');
        if (!si.nearbyObstacle) need.push('주변 지장물 간섭 여부');
        if (si.nearbyObstacle === '있음' && !String(si.nearbyObstacleMeasure || '').trim()) need.push('지장물 조치내용');
        if (need.length) {
          this.noti('입력 필요', `차량계건설기계 작업 계획서 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 차량형 고소작업대: 장비별 필수 + 지형·지반/주변 지장물 간섭 + 작업순서 위험요인·현재조치
      if (this.heavyWorkTypes.includes('차량형 고소작업대')) {
        const p = this.boomLiftPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (!String(e.registrationNo || '').trim()) miss.push('자동차등록번호');
          if (!String(e.insuranceStatus || '').trim()) miss.push('보험여부');
          if (!String(e.maxWorkHeight || '').trim()) miss.push('최대 작업높이');
          if (!String(e.platformSpec || '').trim()) miss.push('작업대 규격');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        if (!(si.outriggerConditions && si.outriggerConditions.length)) need.push('아웃트리거 설치장소');
        if (si.outriggerSlopeCheck && !String(si.outriggerSlopeText || '').trim()) need.push('아웃트리거 받침대 경사');
        if (si.outriggerSpecialCheck && !String(si.outriggerSpecialText || '').trim()) need.push('아웃트리거 특이사항');
        if (!((si.outriggerReinforcements && si.outriggerReinforcements.length) || (si.outriggerReinforcementOther && String(si.outriggerReinforcementOtherText || '').trim()))) need.push('아웃트리거 보강방법');
        if (si.outriggerReinforcementOther && !String(si.outriggerReinforcementOtherText || '').trim()) need.push('아웃트리거 보강방법 기타');
        if (!((si.accessRestrictions && si.accessRestrictions.length) || (si.accessRestrictionOther && String(si.accessRestrictionOtherText || '').trim()))) need.push('작업반경 내 출입금지 조치');
        if (si.accessRestrictionOther && !String(si.accessRestrictionOtherText || '').trim()) need.push('출입금지 조치 기타');
        if (!si.obstacleCheck) need.push('작업대 주변 등 지장물 간섭여부');
        if (si.obstacleCheck === '있음' && !String(si.obstacleMeasure || '').trim()) need.push('지장물 간섭 조치');
        const hasValidProc = (p.procedures || []).some((pr) =>
          String(pr.riskFactor || '').trim() && String(pr.currentMeasure || '').trim());
        if (!hasValidProc) need.push('작업순서(위험요인·현재 안전보건조치)');
        if (need.length) {
          this.noti('입력 필요', `차량형 고소작업대 작업계획서 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 시저형 고소작업대: 장비별 필수 + 지형·지반/주변 지장물 간섭 + 작업순서 + 안전인증 사본 첨부
      if (this.heavyWorkTypes.includes('시저형 고소작업대')) {
        const p = this.scissorLiftPermit;
        const need = [];
        (p.equipmentList || []).forEach((e, i) => {
          const miss = [];
          if (!String(e.manufacturer || '').trim()) miss.push('제조사');
          if (!String(e.modelNo || '').trim()) miss.push('형식번호');
          if (!String(e.safetyCertDate || '').trim()) miss.push('안전인증일');
          if (!String(e.maxWorkHeight || '').trim()) miss.push('작업대 최대높이');
          if (!String(e.ratedLoad || '').trim()) miss.push('정격하중');
          if (!String(e.platformSpec || '').trim()) miss.push('작업대');
          if (miss.length) need.push(`장비 ${i + 1}(${miss.join('/')})`);
        });
        const si = p.siteInvestigation || {};
        if (!(si.groundConditions && si.groundConditions.length)) need.push('견고한 지반, 작업장소 경사');
        if (si.slopeCheck && !String(si.slopeText || '').trim()) need.push('경사');
        if (si.specialNoteCheck && !String(si.specialNoteText || '').trim()) need.push('특이사항');
        if (!((si.accessRestrictions && si.accessRestrictions.length) || (si.accessRestrictionOther && String(si.accessRestrictionOtherText || '').trim()))) need.push('작업반경 내 출입금지 조치');
        if (si.accessRestrictionOther && !String(si.accessRestrictionOtherText || '').trim()) need.push('출입금지 조치 기타');
        if (!si.obstacleCheck) need.push('작업대 주변 등 지장물 간섭여부');
        if (si.obstacleCheck === '있음' && !String(si.obstacleMeasure || '').trim()) need.push('지장물 간섭 조치');
        const hasValidProc = (p.procedures || []).some((pr) =>
          String(pr.riskFactor || '').trim() && String(pr.currentMeasure || '').trim());
        if (!hasValidProc) need.push('작업순서(위험요인·현재 안전보건조치)');
        const certDoc = (p.attachmentDocs || []).find((d) => d.key === 'safetyCert');
        if (!certDoc || !certDoc.checked || !(certDoc.files && certDoc.files.length)) need.push('첨부서류: 안전인증 사본');
        if (need.length) {
          this.noti('입력 필요', `시저형 고소작업대 작업계획서 필수 항목을 입력해야 합니다: ${need.join(', ')}`, 'warning');
          return;
        }
      }
      // 서류업로드: 산재보험가입증명서 필수 (서버 업로드 성공까지 요구)
      //  업로드 실패 시 코드가 원본 File 을 임시 보관하므로(재시도 유도) 단순 null 검사만으로는
      //  '서버에 파일이 없는데 통과' 가 된다. 서버가 발급한 id 가 있어야 실제 저장된 것.
      if (!this.insuranceFile) {
        this.noti('입력 필요', '산재보험가입증명서를 첨부해야 합니다.', 'warning');
        return;
      }
      if (!this.insuranceFile.id) {
        this.noti('업로드 미완료',
          '산재보험가입증명서가 서버에 업로드되지 않았습니다. 파일을 다시 첨부해 주세요.', 'warning');
        return;
      }

      // 선택한 모든 위험작업 양식의 '작업기간' 필수.
      //  기존에는 전기작업 한 곳에서만 검증하고 있어, 나머지 13종은 작업기간을 비워도 다음으로 넘어갔다.
      const periodForms = [
        { active: this.highRiskTargets.includes('고소작업'), permit: this.highAltitudePermit, label: '고소작업' },
        { active: this.highRiskTargets.includes('화기작업'), permit: this.fireWorkPermit, label: '화기작업' },
        { active: this.highRiskTargets.includes('밀폐공간'), permit: this.confinedSpacePermit, label: '밀폐공간' },
        { active: this.highRiskTargets.includes('화학물질'), permit: this.chemicalPermit, label: '화학물질' },
        { active: this.highRiskTargets.includes('전기작업'), permit: this.electricWorkPermit, label: '전기작업' },
        { active: this.highRiskTargets.includes('중량물취급'), permit: this.heavyLiftPermit, label: '중량물취급' },
        { active: this.highRiskTargets.includes('운전중작업'), permit: this.operatingWorkPermit, label: '운전중작업' },
        { active: this.heavyWorkTypes.includes('굴착작업'), permit: this.excavationPermit, label: '굴착작업' },
        { active: this.heavyWorkTypes.includes('차량계하역운반기계'), permit: this.cargoEquipPermit, label: '차량계하역운반기계' },
        { active: this.heavyWorkTypes.includes('이동식크레인작업'), permit: this.mobileCranePermit, label: '이동식크레인작업' },
        { active: this.heavyWorkTypes.includes('차량계건설기계 작업'), permit: this.constrEquipPermit, label: '차량계건설기계 작업' },
        { active: this.heavyWorkTypes.includes('지게차'), permit: this.forkliftPermit, label: '지게차' },
        { active: this.heavyWorkTypes.includes('차량형 고소작업대'), permit: this.boomLiftPermit, label: '차량형 고소작업대' },
        { active: this.heavyWorkTypes.includes('시저형 고소작업대'), permit: this.scissorLiftPermit, label: '시저형 고소작업대' }
      ];
      const periodMiss = periodForms
        .filter((f) => f.active && f.permit)
        .filter((f) => !(f.permit.workPeriod && f.permit.workPeriod.length === 2
          && f.permit.workPeriod[0] && f.permit.workPeriod[1]))
        .map((f) => f.label);
      if (periodMiss.length) {
        this.noti('입력 필요', `다음 허가서의 작업기간을 입력해야 합니다: ${periodMiss.join(', ')}`, 'warning');
        return;
      }

      // 작업순서 및 안전작업방법: 각 행 위험요인·현재안전보건조치 필수 (해당 양식 선택 시)
      const procForms = [
        { active: this.highRiskTargets.includes('전기작업'), permit: this.electricWorkPermit, label: '전기작업' },
        { active: this.highRiskTargets.includes('중량물취급'), permit: this.heavyLiftPermit, label: '중량물작업' },
        { active: this.heavyWorkTypes.includes('굴착작업'), permit: this.excavationPermit, label: '굴착작업' },
        { active: this.heavyWorkTypes.includes('차량계하역운반기계'), permit: this.cargoEquipPermit, label: '차량계하역운반기계' },
        { active: this.heavyWorkTypes.includes('이동식크레인작업'), permit: this.mobileCranePermit, label: '이동식크레인작업' },
        { active: this.heavyWorkTypes.includes('차량계건설기계 작업'), permit: this.constrEquipPermit, label: '차량계건설기계 작업' },
        { active: this.heavyWorkTypes.includes('지게차'), permit: this.forkliftPermit, label: '지게차' },
        { active: this.heavyWorkTypes.includes('차량형 고소작업대'), permit: this.boomLiftPermit, label: '차량형 고소작업대' },
        { active: this.heavyWorkTypes.includes('시저형 고소작업대'), permit: this.scissorLiftPermit, label: '시저형 고소작업대' },
      ];
      const procRowInUse = (p) => !!(String(p.item || '').trim() || String(p.procedure || '').trim() || String(p.riskFactor || '').trim()
        || String(p.hazard || '').trim() || String(p.currentMeasure || '').trim() || String(p.riskLevel || '').trim() || String(p.additionalMeasure || '').trim());
      for (const pf of procForms) {
        if (!pf.active || !pf.permit) continue;
        const procs = pf.permit.procedures || [];
        for (let i = 0; i < procs.length; i++) {
          const pr = procs[i];
          if (!procRowInUse(pr)) continue;
          const miss = [];
          if (!String(pr.riskFactor || '').trim()) miss.push('위험요인');
          if (!String(pr.currentMeasure || '').trim()) miss.push('현재 안전보건조치');
          if (miss.length) {
            this.noti('입력 필요', `${pf.label} 작업순서 ${i + 1}번 항목의 ${miss.join('·')}을(를) 입력해야 합니다.`, 'warning');
            return;
          }
        }
      }
      try {
        const body = this.buildPermitBody();
        const res = await this.$http.post('/api/public/work-permit?submit=false', body);
        const data = res && res.data ? (res.data.payload || res.data) : null;
        if (data && data.planId) {
          this.planId = data.planId;
        }
        // flow=apply : 외부 작성자(비 SSO)의 최종확인 진입 표시.
        // 이 경우 조회 API 를 SSO 예외 별칭(/api/public/work-permit/view/...)으로 호출한다.
        this.$router.push({ path: '/app/workPermit/check', query: { planId: this.planId, flow: 'apply' } });
      } catch (e) {
        console.log('임시저장 실패', e);
        this.noti('저장 오류', '작업 허가서 임시저장 중 오류가 발생했습니다.', 'danger');
      }
    },
    /**
     * 양식 전체 데이터를 BE 가 기대하는 body 형태로 직렬화.
     * 정규 컬럼 필드는 그대로 두고, 그 외 모든 양식 상태를 같은 객체에 담아 보내면
     * BE 에서 정규 컬럼만 추출하고 나머지는 payload(JSON) 로 보관함.
     */
    buildPermitBody() {
      return {
        planId: this.planId,
        planName: this.planName,
        companyName: this.companyName,
        workManager: this.workManager,
        workManagerPhone: this.workManagerPhone,
        workPeopleCount: this.workPeopleCount,
        safetyManager: this.safetyManager,
        safetyManagerPhone: this.safetyManagerPhone,
        idcCode: this.selectedIdcCode,
        planDateRange: this.planDateRange,
        selectedFloorKeys: this.selectedFloorKeys,
        locationDetail: this.locationDetail,
        scheduleRows: this.scheduleRows,
        rows: this.rows,
        highRiskTargets: this.highRiskTargets,
        isHeavyWork: this.isHeavyWork,
        heavyWorkTypes: this.heavyWorkTypes,
        cargoRows: this.cargoRows,
        // 14종 허가서 양식
        excavationPermit: this.excavationPermit,
        cargoEquipPermit: this.cargoEquipPermit,
        mobileCranePermit: this.mobileCranePermit,
        constrEquipPermit: this.constrEquipPermit,
        forkliftPermit: this.forkliftPermit,
        boomLiftPermit: this.boomLiftPermit,
        scissorLiftPermit: this.scissorLiftPermit,
        fireWorkPermit: this.fireWorkPermit,
        highAltitudePermit: this.highAltitudePermit,
        confinedSpacePermit: this.confinedSpacePermit,
        electricWorkPermit: this.electricWorkPermit,
        chemicalPermit: this.chemicalPermit,
        operatingWorkPermit: this.operatingWorkPermit,
        heavyLiftPermit: this.heavyLiftPermit,
        consent: this.readConsent(),
        schemaVersion: 1
      };
    },
    /** 약관 동의 화면(WorkPermitAgree)에서 sessionStorage 에 저장한 동의 정보. */
    readConsent() {
      try {
        return JSON.parse(sessionStorage.getItem('workPermitConsent') || 'null');
      } catch (e) {
        return null;
      }
    },
    addSet(row) {
      if (!row.sets) {
        this.$set(row, 'sets', []);
      }
      row.sets.push(this.createSet());
    },
    removeSet(row, index) {
      if (!row.sets || row.sets.length <= 1) return;
      row.sets.splice(index, 1);
    },
    extractHazardText(value) {
      if (!value) return '';
      if (Array.isArray(value)) {
        return value.map((h) => (typeof h === 'string' ? h : (h.category ? `${h.category}/${h.name}` : h.name || ''))).filter(Boolean).join(', ');
      }
      if (typeof value === 'string') return value;
      if (value.name) return value.category ? `${value.category}/${value.name}` : value.name;
      return '';
    },
    loadProceduresInto(permitKey) {
      const procedures = this.buildProceduresFromRows();
      if (!procedures.length) {
        alert('작업위험성평가에 입력된 작업 항목이 없습니다.');
        return;
      }
      if (!this[permitKey]) return;
      this[permitKey].procedures = procedures;
    },
    buildProceduresFromRows() {
      const procedures = [];
      (this.rows || []).forEach((row) => {
        (row.sets || []).forEach((set) => {
          const hazard = this.extractHazardText(set.hazard);
          const procedure = typeof set.procedure === 'string' ? set.procedure : '';
          const riskFactor = typeof set.riskFactor === 'string' ? set.riskFactor : '';
          const currentSafety = typeof set.currentSafety === 'string' ? set.currentSafety : '';
          const additionalSafety = typeof set.additionalSafety === 'string' ? set.additionalSafety : '';
          const riskLevel = typeof set.riskLevel === 'string' ? set.riskLevel : '';
          if (!row.item && !procedure && !riskFactor && !hazard && !currentSafety && !additionalSafety && !riskLevel) return;
          procedures.push({
            item: row.item || '',
            procedure,
            riskFactor,
            hazard,
            currentMeasure: currentSafety,
            riskLevel,
            additionalMeasure: additionalSafety
          });
        });
      });
      return procedures;
    },
    toArray(value) {
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    },
    getDisabledHazards(row, setIndex) {
      if (!row || !row.sets) return [];
      const used = [];
      row.sets.forEach((set, idx) => {
        if (idx === setIndex) return;
        if (set && set.hazard) {
          if (typeof set.hazard === 'string') {
            used.push(set.hazard);
          } else if (set.hazard.key) {
            used.push(set.hazard.key);
          } else if (set.hazard.name) {
            used.push(set.hazard.name);
          }
        }
      });
      return used;
    },
    applyHazardSelection(row, setIndex, selectedList) {
      const list = Array.isArray(selectedList) ? selectedList : this.toArray(selectedList);
      if (list.length === 0) {
        this.$set(row.sets[setIndex], 'hazard', '');
        return;
      }
      this.$set(row.sets[setIndex], 'hazard', list[0]);
      for (let i = 1; i < list.length; i += 1) {
        row.sets.push({ ...this.createSet(), hazard: list[i] });
      }
    },
    openSafetyModal(row, setIndex) {
      this.openModal({
        view: 'modal/WorkPermitSafety',
        side: false,
        title: '안전대책 입력',
        showBottom: false,
        props: {
          value: row.sets[setIndex].safetyPlan,
          onConfirm: (value) => {
            this.$set(row.sets[setIndex], 'safetyPlan', value);
          }
        }
      });
    }
  }
}
</script>

<style>
/* 고위험 작업계획 탭: 폭이 모자라면 압축되어 라벨이 26px 탭 아래로 넘치던 문제 →
   여러 단으로 자연스럽게 줄바꿈(2단 이상)하고, 각 탭 라벨은 한 줄 유지해 탭 높이에 맞춤 */
.wp-hr-tabs.nav-tabs {
  flex-wrap: wrap;
  row-gap: 4px;
}
.wp-hr-tabs.nav-tabs .nav-item a {
  white-space: nowrap;
}

/* 이전 허가서 불러오기 모달 */
.wp-load-modal-bg {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 16px;
  overflow: auto;
}
.wp-load-modal {
  background: #fff;
  border-radius: 6px;
  width: 100%;
  max-width: 760px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}
.wp-load-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e2e2e2;
}
.wp-load-modal-body {
  padding: 18px;
}

/* 넓은 표(공정표·작업항목)가 카드를 넘칠 때 가로 스크롤 처리 */
.wp-table-scroll {
  overflow-x: auto;
  max-width: 100%;
}
/* 컨테이너 폭이 좁아도 열이 압축되지 않고 스크롤되도록 최소 폭 고정 (colgroup 합계) */
.wp-schedule-table {
  min-width: 1390px;
}
.wp-workitem-table {
  min-width: 1680px;
}
/* 선택된 작업위치 — 텍스트 나열 대신 태그(칩)로 표시 */
.wp-selected-locs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.table-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.table-list-item {
  display: flex;
  gap: 6px;
  align-items: center;
}
.table-list-item .form-control {
  min-width: 120px;
}
.table-list .btn {
  align-self: flex-start;
}
.wp-risk-badge {
  display: inline-block;
  min-width: 28px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  line-height: 1.4;
}
.wp-risk-badge-high { background-color: #EB5757; }
.wp-risk-badge-mid  { background-color: #F2C94C; color: #5a4500; }
.wp-risk-badge-low  { background-color: #27AE60; }
.wp-risk-guide-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  font-size: 12px;
}
.wp-risk-guide-table th,
.wp-risk-guide-table td {
  border: 1px solid #ddd;
  padding: 6px 10px;
  vertical-align: middle;
}
.wp-risk-guide-table th {
  background: #f5f5f5;
  font-weight: 600;
  text-align: center;
}
.wp-risk-guide-table td.risk-level-cell {
  text-align: center;
  width: 60px;
}
.wp-timeline {
  table-layout: fixed;
  min-width: 40vw;
}
.wp-hr-tab-content {
  border: 1px solid #ddd;
  border-top: none;
  padding: 20px;
  background: #fff;
}
.wp-hr-tab-placeholder {
  padding: 40px 0;
  text-align: center;
}
.wp-timeline th.wp-timeline-day {
  padding: 4px 0;
  text-align: center;
  border-left: 1px dotted #bdbdbd;
}
.wp-timeline td.wp-timeline-empty,
.wp-timeline td.wp-timeline-span {
  padding: 0;
  border-left: 1px dotted #bdbdbd;
}
.wp-timeline td.wp-timeline-empty {
  height: 30px;
}
.wp-timeline-bar {
  height: 14px;
  border-radius: 4px;
  margin: 6px 2px;
}
.wp-risk-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}
.wp-risk-sub {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  margin-left: 24px;
  padding: 8px 12px;
  border-left: 2px solid #e2e2e2;
  background: #fafafa;
}
.risk-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.risk-item .md-check {
  margin-right: 0;
}
.risk-tooltip-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #9e9e9e;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  cursor: default;
  margin-left: 4px;
  vertical-align: middle;
  line-height: 1;
  flex-shrink: 0;
  user-select: none;
}
</style>
